/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  convertStringToArray,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  formatEchannelResponse,
  getArrayToString,
  getStringToArray,
  isEmptyObject,
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
} from '../../../../utils';

// constant
import { ECHANNEL_HOST_TO_HOST, ECHANNEL_HSBCAPI, ECHANNEL_HSBCNET, FORM_REFS } from '../../../../constants';

// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';

// children
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import Checkbox from '../../../common/Checkbox/Checkbox';
import DateSelector from '../../../common/DateSelector/DateSelector';
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import Radiobutton from '../../../common/Radio/radioButton';
import SimpleDropdown from '../../../common/SimpleDropdown';
import SingleLineSelect from '../../../common/SingleLineSelect';
import Tooltip from '../../../common/Tooltip';
import { EditProductEnablementModal } from '../../Modals';

//action Creator
import { hideActionButton } from '../../../layouts/actions/actionCreator';
import {
  reSetEChannelActiveTabIndex,
  setAddresses,
  setCurrentProductEchannel,
  setCurrentProductEchannelStatuses,
  setEChannelActiveTabIndex,
  setPersons
} from '../../actions/actionCreator';
//style
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../common/Modal';
import TelephoneNumber from '../../../common/TelephoneNumber';
import OtherProductsListModal from '../../Modals/OtherProductsListModal';
import './styles.css';

const CFF = 'Cash Flow Forecasting'

class CaptureProductEchannel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentEchannel: {},
      productEnablement: {},
      productEnablements: [],
      noOfEchannelContacts: 1,
      noOfSystemAdmins: 1,
      systemAdmins: [],
      productsList: [],
      otherProductsList: [],
      selectedProducts: [],
      selectedOtherProducts: "",
      reportingAllAccounts: true,
      accountsReportingToEchannel: [],
      securityDev: [],
      selectedAccounts: [],
      selectedOtherAccounts: [],
      noOfOtherAccounts: 0,
      showOtherProductsListDialog: false,
      showEditProductEnablementDialog: false,
      productsCheckBoxesState: {},
      accountsSelectionCheckboxesState: {},
      inputInValidArr: [],
      setDisable: false,
      showSecurityTooltip: false,
      disableAccessControlContact: [],
      disableEchannelContact: [],
      existingEntityData: [],
      accountsRelatedToEchannel: [],
      telephoneCountryCodes: [],
      telephoneAreaCodes: [],
      basicDetails: {},
      convertEchannelModal: { show: false },
      profileLevelProductsCheckBoxesState: {},
      selectedProfileLevelProducts: [],
      otherAccountLevelProducts: "",
      otherProfileLevelProducts: ""
    };
    this.disableList = [];
    this.disableContact = [];

    this.productEnablemanetList = [
      {
        description: "Account information (AI)",
        id: "AI"
      },
      {
        description: "Priority payments (PP)",
        id: "PP"
      },
      {
        description: "ACH - debits (ACHD)",
        id: "ACHD"
      },
      {
        description: "File upload (FU)",
        id: "FU"
      },
      {
        description: "Internet trade service enquiry (ITSE)",
        id: "ITSE"
      }
    ];
  }

  getAccountCountryTaxanomy = () => {
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_productEnablement.accountTaxonomy))
      .then(({ data }) => {
        this.setState({ countryAccountList: data.responseData.countryTaxonomy.classificationNodes })
        this.getAccountsRelatedToEchannel();
      });
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_basicDetails.countryTaxonomy))
      .then(({ data }) => {
        this.setState({ countryTranslationList: data.responseData.classificationNodes })
        this.getTranslatedCountry(this.state.currentEchannel);
        this.getTaxanomyUrl();
      });
  }

  getTaxanomyUrl = () => {
    let addresses = this.state.addresses;
    if (addresses !== undefined) {
      if (this.state.countryTranslationList !== undefined) {
        addresses = addresses.map(item => {
          this.state.countryTranslationList.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
              }
            }
            return item;
          });

          this.setState([...addresses]);
        });
      }
    }
  }

  setCaptureProductEchannelPageState = (data) => {
    var { productId, caseId } = this.props.match.params;
    const currentEchannel = formatEchannelResponse({ ...data.responseData });

    data.responseData.productId = productId;

    this.props.setCurrentProductEchannel({ ...currentEchannel });
    this.getAccountCountryTaxanomy();
    this.setState({
      caseId: caseId,
      currentEchannel,
      systemAdmins: data.responseData.eChannelAdmins
    });
    if (typeof currentEchannel.accessControl !== 'undefined' && typeof currentEchannel.accessControl.securityMethod !== 'undefined' &&
      currentEchannel.accessControl.securityMethod.value === "securityDevice") {
      eapiClient("/product/taxonomies/security-device")
        .then(({ data }) => {
          this.setState({ securityDev: data.responseData.classificationNodes });
        });
    }
    else if (typeof currentEchannel.accessControl !== 'undefined' && typeof currentEchannel.accessControl.securityMethod !== 'undefined' &&
      currentEchannel.accessControl.securityMethod.value === "securityAndMobileDevice") {
      eapiClient("/product/taxonomies/security-mobile-device")
        .then(({ data }) => {
          this.setState({ securityDev: data.responseData.classificationNodes });
        });
    }
    const _eChannelContacts = currentEchannel.eChannelContacts;
    const _eChannelAdmins = currentEchannel.eChannelAdmins;
    const _otherAccounts = currentEchannel.otherAccounts;
    if (_eChannelContacts && _eChannelContacts.length > 0 && this.state.noOfEchannelContacts !== _eChannelContacts.length) {
      this.setState({ noOfEchannelContacts: _eChannelContacts.length });
    }
    if (_eChannelAdmins && _eChannelAdmins.length > 0 && this.state.noOfSystemAdmins !== _eChannelAdmins.length) {
      this.setState({ noOfSystemAdmins: _eChannelAdmins.length });
    }
    if (_otherAccounts && _otherAccounts.length > 0 && this.state.noOfOtherAccounts !== _otherAccounts.length) {
      this.setState({ noOfOtherAccounts: _otherAccounts.length });
    }
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }
  translateWordForOption = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }


  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  loadPageState = () => {
    var { productId, caseId } = this.props.match.params;

    eapiClient("/product/echannel/" + productId)
      .then(({ data, status }) => {
        const currentEchannel = formatEchannelResponse({ ...data.responseData });
        this.setCaptureProductEchannelPageState(data);
        let selectedAccessContrlContact = data.responseData.eChannelAdmins.map(item => item && item.id)
        let selectedEchannelContact = data.responseData.eChannelContacts.map(item => item && item.id)
        this.disableContact = selectedEchannelContact;
        this.disableList = selectedAccessContrlContact;
        if (currentEchannel.accessControl !== undefined && this.state.pageAccessControlJson !== undefined) {
          if (currentEchannel.accessControl.adminControl.value === "soleAuthority") {
            this.setState({
              caseId: caseId,
              hintTextNo: `${this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.title2}`,
              disableAccessControlContact: this.disableList,
              disableEchannelContact: this.disableContact,
            })
          } else {
            this.setState({
              caseId: caseId,
              hintTextNo: `${this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.title3}`,
              disableAccessControlContact: this.disableList,
              disableEchannelContact: this.disableContact
            })
          }
        }
        const { profileLevelProducts } = this.state;

        // Get array of selected product IDs from response
        const selectedIds = data.responseData.profileLevelProducts.map(p => p.id);
        const profileLevelProductsCheckBoxesState = {};
        data.responseData.profileLevelProducts.forEach(product => {
          profileLevelProductsCheckBoxesState[product.id] = selectedIds.includes(product.id);
        });

        // Set in state
        this.setState({
          profileLevelProductsCheckBoxesState,
          selectedProfileLevelProducts: selectedIds
        });

        this.setState({
          disableAccessControlContact: this.disableList,
          disableEchannelContact: this.disableContact,
          currentEchannelType: currentEchannel,
          otherProfileLevelProducts: data.responseData.otherProfileLevelProducts ? data.responseData.otherProfileLevelProducts : ''
          // profileLevelProductsCheckBoxesState: ['urn:hsbc:cmb:gdocs:products:taxonomies:API:VAM']
        })
        let productListSetType;

        if (currentEchannel.eChannelType && currentEchannel.eChannelType.value === ECHANNEL_HSBCNET) {
          productListSetType = ECHANNEL_HSBCNET;
        } else if (this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCAPI) {
          productListSetType = ECHANNEL_HSBCAPI;
        } else {
          productListSetType = ECHANNEL_HOST_TO_HOST;
        }
        if (this.props.lang.currentLang.lang === 'Spanish') {
          this.getProductList(productListSetType, '?lang=es');
        } else if (this.props.lang.currentLang.lang === 'Bahasa') {
          this.getProductList(productListSetType, '?lang=ba');
        } else if (this.props.lang.currentLang.lang === 'English') {
          this.getProductList(productListSetType);
        }

        eapiClient("/product/account/eChannelReport/" + currentEchannel.id + "/case/" + currentEchannel.caseId)
          .then(({ data }) => {
            this.setState({ accountsReportingToEchannel: data.responseData });
          });
      });
  }

  getTranslatedCountry = (product) => {

    if (this.state.countryTranslationList !== undefined) {
      this.state.countryTranslationList.filter(countItem => {
        if ('country' in product) {
          if (countItem.id === product.country.value) {
            product.country.name = countItem.name
          }
        }
        return product;
      });
      this.setState({ currentEchannel: product });

    }
  }

  getAccountsRelatedToEchannel = () => {
    let accounts = this.state.accountsReportingToEchannel;
    let otherAccounts = this.state.currentEchannel.otherAccounts;
    if (this.state.countryAccountList !== undefined) {
      if (accounts !== undefined) {
        accounts = accounts.map(item => {
          this.state.countryAccountList.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
                if (item.accountType !== undefined) {
                  countItem.associations.filter(accountType => {
                    if (accountType.id === item.accountType.value) {
                      item.accountType.name = accountType.name
                    }
                  })
                }
              }
            }
            return item;
          });
          this.setState({ accountsReportingToEchannel: accounts });
        });
      }
    }
    if (this.state.countryAccountList !== undefined) {
      if (otherAccounts !== undefined) {
        otherAccounts = otherAccounts.map(item => {
          this.state.countryAccountList.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
              }
            }
            return item;
          });
          this.setState({ otherAccountsReportingToEchannel: otherAccounts });
        });
      }
    }
  }


  getProductList = (productListSetType, lang) => {
    let langParam = lang !== undefined ? lang : ''
    taxonomyHostClient("/product/taxonomies/" + productListSetType + langParam)
      .then(({ data }) => {
        this.setState({
          productsList: data.responseData.classificationNodes,
          otherProductsList: data.responseData.others && data.responseData.others,
          swiftnetProductList: data.responseData.swiftNet && data.responseData.swiftNet,
          profileLevelProducts: data.responseData.profileLevelProducts && data.responseData.profileLevelProducts
        });

      });
  }


  getUpdatedSystemAdminDateOfBirth = (updatedId) => {
    let person = this.props.persons.find(person => person.id === updatedId)
    return (person && person.dateOfBirth) || ''
  }

  updateDropdown() {
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    if (getCurrentDropDownName === 'systemAdmins' || getCurrentDropDownName === 'deliveryAddress' || getCurrentDropDownName === 'eChannelContacts' || getCurrentDropDownName === 'addressId') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }
    let _systemAdmins = [...this.state.systemAdmins];
    if (this.state.systemAdmins.length > 0 && getCurrentDropDownName === 'systemAdmins') {
      this.state.systemAdmins.forEach((currentValue, index, arr) => {
        if (currentValue.id !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
          _systemAdmins[index] = {
            ...this.state.systemAdmins[index],
            id: getCurrentDropDownValue,
            dateOfBirth: this.getUpdatedSystemAdminDateOfBirth(getCurrentDropDownValue)
          }

          let disableItem = _systemAdmins.map(item => item.id)
          this.disableList = disableItem
          this.setState({
            systemAdmins: _systemAdmins,
            disableAccessControlContact: disableItem
          });
        } else if (getCurrentDropDownValue !== null && getCurrentDropDownName === 'systemAdmins') {
          _systemAdmins[getCurrentDropDownIndex - 1] = {
            ...this.state.systemAdmins[getCurrentDropDownIndex - 1],
            id: getCurrentDropDownValue,
            dateOfBirth: this.getUpdatedSystemAdminDateOfBirth(getCurrentDropDownValue)
          }
          let disableItem = _systemAdmins.map(item => item.id)
          this.disableList = disableItem
          this.setState({
            systemAdmins: _systemAdmins,
            disableAccessControlContact: disableItem
          });
        }
      })
    } else if (getCurrentDropDownName === 'systemAdmins' && getCurrentDropDownValue !== null) {
      _systemAdmins[getCurrentDropDownIndex - 1] = {
        ...this.state.systemAdmins[getCurrentDropDownIndex - 1],
        id: getCurrentDropDownValue,
        dateOfBirth: this.getUpdatedSystemAdminDateOfBirth(getCurrentDropDownValue)
      }
      let disableItem = _systemAdmins.map(item => item.id)
      this.disableList = disableItem
      this.setState({
        systemAdmins: _systemAdmins,
        disableAccessControlContact: disableItem
      });
    }

    if (this.state.systemAdmins.length > 0 && getCurrentDropDownName === 'deliveryAddress') {
      this.state.systemAdmins.forEach((currentValue, index, arr) => {
        if (currentValue.deliveryAddress !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
          this.disableList = this.state.disableAccessControlContact;
          _systemAdmins[index] = {
            ...this.state.systemAdmins[index],
            deliveryAddress: getCurrentDropDownValue
          }
          this.setState({
            systemAdmins: _systemAdmins
          }, () => { });
        } else if (getCurrentDropDownValue !== null && getCurrentDropDownName === 'deliveryAddress') {
          this.disableList = this.state.disableAccessControlContact;
          _systemAdmins[getCurrentDropDownIndex - 1] = {
            ...this.state.systemAdmins[getCurrentDropDownIndex - 1],
            deliveryAddress: getCurrentDropDownValue
          }
          this.setState({
            systemAdmins: _systemAdmins
          }, () => { });
        }
      })
    } else if (getCurrentDropDownName === 'deliveryAddress' && getCurrentDropDownValue !== null) {
      this.disableList = this.state.disableAccessControlContact;
      _systemAdmins[getCurrentDropDownIndex - 1] = {
        ...this.state.systemAdmins[getCurrentDropDownIndex - 1],
        deliveryAddress: getCurrentDropDownValue
      }
      this.setState({
        systemAdmins: _systemAdmins
      }, () => { });
    }
    if ('eChannelContacts' in this.state.currentEchannel) {
      if (this.state.currentEchannel.eChannelContacts.length > 0 && getCurrentDropDownName === 'eChannelContacts') {
        let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
        this.state.currentEchannel.eChannelContacts.forEach((currentValue, index, arr) => {
          if (currentValue.id !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
            _eChannelContacts[index] = {
              ...this.state.currentEchannel.eChannelContacts[index],
              id: getCurrentDropDownValue
            }
            let disableItem = _eChannelContacts.map(item => item.id)
            this.disableContact = disableItem
            this.setState({
              currentEchannel: {
                ...this.state.currentEchannel,
                eChannelContacts: _eChannelContacts
              },
              disableEchannelContact: disableItem
            });
          } else if (getCurrentDropDownValue !== null && getCurrentDropDownName === 'eChannelContacts') {
            _eChannelContacts[getCurrentDropDownIndex - 1] = {
              ...this.state.currentEchannel.eChannelContacts[getCurrentDropDownIndex - 1],
              id: getCurrentDropDownValue
            }
            let disableItem = _eChannelContacts.map(item => item.id)
            this.disableContact = disableItem
            this.setState({
              currentEchannel: {
                ...this.state.currentEchannel,
                eChannelContacts: _eChannelContacts
              },
              disableEchannelContact: disableItem
            });
          }
        })
      } else if (getCurrentDropDownName === 'eChannelContacts' && getCurrentDropDownValue !== null) {
        let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];

        let disableItem = _eChannelContacts.map(item => item.id)
        this.disableContact = disableItem

        _eChannelContacts[getCurrentDropDownIndex - 1] = {
          ...this.state.currentEchannel.eChannelContacts[getCurrentDropDownIndex - 1],
          id: getCurrentDropDownValue
        }
        this.setState({
          currentEchannel: {
            ...this.state.currentEchannel,
            eChannelContacts: _eChannelContacts
          },
          disableEchannelContact: disableItem
        });
      }

      if (this.state.currentEchannel.eChannelContacts.length > 0 && getCurrentDropDownName === 'addressId') {
        let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
        this.state.currentEchannel.eChannelContacts.forEach((currentValue, index, arr) => {
          if (currentValue.addressId !== getCurrentDropDownValue && index === getCurrentDropDown - 1) {
            _eChannelContacts[index] = {
              ...this.state.currentEchannel.eChannelContacts[index],
              addressId: getCurrentDropDownValue
            }
            this.setState({ currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts } });
          } else if (getCurrentDropDownValue !== null && getCurrentDropDownName === 'addressId') {
            _eChannelContacts[getCurrentDropDownIndex - 1] = {
              ...this.state.currentEchannel.eChannelContacts[getCurrentDropDownIndex - 1],
              addressId: getCurrentDropDownValue
            }
            this.setState({ currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts } });
          }
        })
      } else if (getCurrentDropDownName === 'addressId' && getCurrentDropDownValue !== null) {
        let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
        _eChannelContacts[getCurrentDropDownIndex - 1] = {
          ...this.state.currentEchannel.eChannelContacts[getCurrentDropDownIndex - 1],
          addressId: getCurrentDropDownValue
        }
        this.setState({ currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts } });
      }
    }
  }

  componentDidMount() {
    var { caseId, productId } = this.props.match.params;

    // Main page json
    aemHostClient("/aemData/formData/json_echannel-details")
      .then(({ data }) => {
        // document.title =`${data.title} - ${'HSBC GLCM'}`;
        this.setState({ pageJson: data });

        var prevStatePresent = loadIfStateAvailableInSessionStorage(this, null, () => {
          this.loadPageState();
        });

        eapiClient("/persons/case/" + caseId)
          .then(({ data }) => {
            this.props.setPersons(data.responseData);
            this.getCountryListForPerson();

            return eapiClient("/addresses/case/" + caseId)
          }).then(({ data }) => {
            this.setState({ addresses: data.responseData });
            this.getTaxanomyUrl();
            this.props.setAddresses(data.responseData);
          });

        if (prevStatePresent) {
          eapiClient("/product/echannel/" + productId)
            .then(({ data, status }) => {
              // setting updated other accounts back to state
              this.setState({
                currentEchannel: { ...this.state.currentEchannel, otherAccounts: data.responseData.otherAccounts }
              });
              this.setState({ otherAccountsReportingToEchannel: data.responseData.otherAccounts });
              this.updateDropdown();
            });
        }
      });

    eapiClient("/product/echannel/" + productId + "/echannelDetailsStatus")
      .then(({ data }) => {
        this.props.setCurrentProductEchannelStatuses(data.responseData);
      });

    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:telephoneCountryCodes")
      .then(({ data }) => {
        this.setState({ telephoneCountryCodes: data.responseData.classificationNodes });
      });

    taxonomyHostClient("/product/taxonomies/urn:hsbc:cmb:gdocs:products:taxonomies:telephoneAreaCodes")
      .then(({ data }) => {
        this.setState({ telephoneAreaCodes: data.responseData.classificationNodes });
      });

    // Echannel contage page json
    aemHostClient("/aemData/formData/json_e-channel-contacts-form")
      .then(({ data }) => {
        this.setState({
          pageEchannelContactJson: data
        })

        // Product enablement page json
        return aemHostClient("/aemData/formData/json_e-channel-product-enablement-form")
      }).then(({ data }) => {
        this.setState({
          pageProductEnablementJson: data
        })

        // Echannel Access Control Page
        return aemHostClient("/aemData/formData/json_e-channel-access-control-form")
      }).then(({ data }) => {
        this.setState({
          pageAccessControlJson: data
        })
        taxonomyHostClient(Translations(data.guideContainer.rootPanel.items.guidedropdownlist_currencyPaymentAuthorisation.apiUrl, this.props.lang.currentLang.lang, this.props.lang.translatedData))
          .then(({ data }) => {
            this.setState({ authorisationLimitsCurrencyOptions: data.responseData.classificationNodes });
          });

        return aemHostClient("/aemData/formData/json_product-enablement-account")
      }).then(({ data }) => {
        this.setState({ editProductEnablementModalJson: data });

        let _caseId = Object.keys(this.props.cases)[0]
        let _url = "/entities/existing-organisations/" + _caseId;
        return eapiClient(_url)
      }).then(({ data }) => {
        this.setState({
          ...this.state,
          existingEntityData: data.responseData
        })
      });

    // taxonomyHostClient("/product/taxonomies/paymentAuthorisationCurrency")
    // .then(({data}) => {
    //   this.setState({authorisationLimitsCurrencyOptions: data.responseData.classificationNodes});
    // });


    this.props.hideActionButton();
    this.getConvertEchannelModalJson()
  }
  componentWillReceiveProps(nextProps) {
    let productListSetType;
    if (this.state.currentEchannelType !== undefined) {
      // calling product list api 
      if (this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCNET) {
        productListSetType = ECHANNEL_HSBCNET;
      } else if (this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCNET) {
        productListSetType = ECHANNEL_HSBCAPI;
      }
      else {
        productListSetType = ECHANNEL_HOST_TO_HOST;
      }
    }
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      taxonomyHostClient(Translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_currencyPaymentAuthorisation.apiUrl, this.props.lang.currentLang.lang, this.props.lang.translatedData))
        .then(({ data }) => {
          this.setState({ authorisationLimitsCurrencyOptions: data.responseData.classificationNodes });
        });
      this.getCountryListForPerson();

      this.getAccountCountryTaxanomy('');
      if (nextProps.lang.currentLang.lang === 'Spanish') {
        this.getProductList(productListSetType, '?lang=es');
      } else if (nextProps.lang.currentLang.lang === 'Bahasa') {
        this.getProductList(productListSetType, '?lang=ba');
      } else if (nextProps.lang.currentLang.lang === 'English') {
        this.getProductList(productListSetType);
      }
    }
  }

  getCountryListForPerson = () => {
    let _currentPerson = [...this.props.persons];
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_basicDetails.countryTaxonomy))
      .then(({ data }) => {
        let currentListCountries = data.responseData.classificationNodes;
        _currentPerson = _currentPerson.map(item => {
          currentListCountries.filter(country => {
            if ('countryOfResidence' in item) {
              if (country.id === item.countryOfResidence.value) {
                item.countryOfResidence.name = country.name
              }
            }
            if ('nationality' in item) {
              if (country.id === item.nationality.value) {
                item.nationality.name = country.name
              }
            }
            return item
          })
          this.props.setPersons([..._currentPerson]);
        });
      })
  }
  getBasicDetails = (basicDetails) => {
    if (basicDetails && basicDetails.newEchannel === true && basicDetails.eChannelIdOptional !== undefined) {
      basicDetails.eChannelId = basicDetails.eChannelIdOptional;
    }
    // if (this.state.basicDetails.newEchannel !== basicDetails.newEchannel) {
    //   this.setState({ convertEchannelModal: { show: true, newEchannel: basicDetails.newEchannel } })
    // }
    this.setState({ basicDetails });
  }

  handleOtherProductsSubmit = (checkedProducts = []) => {
    const mapped = []
    const unmapped = []
    const otherProductsList = this.state.otherProductsList
    let listed = checkedProducts.filter(el => !(el.type === "unlistedOtherProducts"))
    listed = [...getStringToArray(getArrayToString(listed, true, true, "description"))]
    let unlisted = checkedProducts.filter(el => el.type === "unlistedOtherProducts")
    unlisted = [...getStringToArray(getArrayToString(unlisted, true, true, "description"))]

    unlisted.map(i => otherProductsList.find(av => av.description.toLowerCase() === i.toLowerCase()) ? mapped.push(
      otherProductsList.find(av => av.description.toLowerCase() === i.toLowerCase()).description) : unmapped.push(i))

    const string = getArrayToString([...listed, ...mapped, ...unmapped], true)

    if (checkedProducts.length) {
      this.setState({
        selectedOtherProducts: string
      })
    }
    this.toggleDialog()
  }

  toggleDialog = () => {
    this.setState({
      showOtherProductsListDialog: false,
      showEditProductEnablementDialog: false
    });
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  // Basic detail
  onBasicDetailTabDataSubmit = (event, apiUrl) => {
    let payload = new BasicDetail();
    payload.setBasicDetailPayload(this.state, this.props);
    var { productId } = this.props.match.params;
    var apiUrls = this.translations(apiUrl)
    let productListSetType;
    if (this.state.basicDetails.eChannelType.value === ECHANNEL_HSBCNET) {
      productListSetType = ECHANNEL_HSBCNET;
    } else if (this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCAPI) {
      productListSetType = ECHANNEL_HSBCAPI;
    } else {
      productListSetType = ECHANNEL_HOST_TO_HOST;
    }
    if (this.props.lang.currentLang.lang === 'Spanish') {
      this.getProductList(productListSetType, '?lang=es');
    } else if (this.props.lang.currentLang.lang === 'Bahasa') {
      this.getProductList(productListSetType, '?lang=ba');
    } else if (this.props.lang.currentLang.lang === 'English') {
      this.getProductList(productListSetType);
    }
    if (payload.data.surAvailable === false) {
      payload.data['sur'] = '';
    }
    eapiClient(apiUrls + '/' + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //get current tab statuses
        this.setCaptureProductEchannelPageState(data);

        eapiClient(apiUrls + '/' + productId + "/echannelDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductEchannelStatuses(data.responseData);
          });

        let _caseId = Object.keys(this.props.cases)[0]
        let _url = "/entities/existing-organisations/" + _caseId;
        eapiClient(_url)
          .then(({ data }) => {
            this.setState({
              ...this.state,
              existingEntityData: data.responseData
            })
          })
      });
  }

  // Access Control and Limit
  onAccessControlAndLimitTabDataSubmit = () => {
    let payload = new AccessControlLimit();
    payload.setAccessControlLimitPayload(this.state, this.props);
    var { caseId, productId } = this.props.match.params;
    this.props.blockUi();
    eapiClient("/product/echannel/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //get current tab statuses
        eapiClient("/product/echannel/" + productId + "/echannelDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductEchannelStatuses(data.responseData);

            eapiClient("/persons/case/" + caseId)
              .then(({ data }) => {
                this.props.setPersons(data.responseData);
                this.getCountryListForPerson();
              });
          });
      });
    this.props.unBlockUi();
  }

  onEchannelContactTabDataSubmit = () => {
    let payload = new EchannelContact();
    payload.setEchannelContactPayload(this.state, this.props);
    var { productId } = this.props.match.params;
    eapiClient("/product/echannel/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //get current tab statuses
        eapiClient("/product/echannel/" + productId + "/echannelDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductEchannelStatuses(data.responseData);
          });
      });
  }

  // Product Enablement
  onProductEnablementTabDataSubmit = () => {
    let payload = new ProductEnablement();
    payload.setProductEnablementPayload(this.state, this.props, this.checkReportingToCFF());

    var { productId } = this.props.match.params;
    eapiClient("/product/echannel/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        //get current tab statuses
        eapiClient("/product/echannel/" + productId + "/echannelDetailsStatus")
          .then(({ data }) => {
            this.props.setCurrentProductEchannelStatuses(data.responseData);
          });
      });
  }

  renderBasicDetailsForm() {
    let formData;
    if (this.state.currentEchannel !== undefined && this.state.currentEchannel.id !== undefined) {
      formData = { ...this.state.currentEchannel };
    } else {
      formData = {};
    }
    const properties = {
      accountId: this.props.match.params.accountId,
      formData,
      editType: 'capture-product-echannel-basic-details',
      existingEntityData: this.state.existingEntityData,
      pathname: this.props.location.pathname,
      toggleConvertEchannelModal: (value) => {
        if (this.state.currentEchannel.newEchannel !== value) {
          this.setState({ convertEchannelModal: { show: true, newEchannel: value } })
        }
      }
    };
    if (this.state.pageJson !== undefined && this.state.pageJson.par.aemform_basicDetails !== undefined) {
      var aemform = this.state.pageJson.par.aemform_basicDetails;
      var formRef = this.state.pageJson.par.aemform_basicDetails.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit"
            customerEchannel="true"
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onBasicDetailTabDataSubmit}
            getFormData={this.getBasicDetails}
            history={this.props.history}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            flag={this.props.lang.currentLangFlag.flag}
          />
        );
      }
    }
  }

  handleAdminControlChange = (event) => {
    var adminControl = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    };
    if (adminControl.value === "soleAuthority") {
      this.setState({ hintTextNo: `${this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.title2}` })
    } else {
      this.setState({ hintTextNo: `${this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.title3}` })
    }
    var accessControl;
    if (!this.state.currentEchannel.accessControl || !this.state.currentEchannel.accessControl.securityMethod) {
      accessControl = { adminControl, securityMethod: {} };
    } else {
      accessControl = { ...this.state.currentEchannel.accessControl, adminControl };
    }
    this.setState({ currentEchannel: { ...this.state.currentEchannel, accessControl } });
  }

  clearSecurityMethodSelections = (value) => {
    var _systemAdmins = [...this.state.systemAdmins];

    if (value === "smartCard") {
      _systemAdmins.forEach((sa, index, ref) => ref[index].numberOfSecurityDevices = undefined);
    } else if (value === "mixedSecurity" || value === "securityDevice") {

    }
    this.setState({ systemAdmins: _systemAdmins });
  }

  updateSystemAdmins = () => {
    let _systemAdm = [...this.state.systemAdmins];
    _systemAdm.map(admins => {
      if (typeof admins.securityDevices !== 'undefined') {
        delete admins.securityDevices
      }
    })
    return _systemAdm
  }

  handleSecurityMethodChange = (event) => {
    this.props.blockUi();
    var securityMethod = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    };
    //Get security device or mobile device taxonomy
    if (securityMethod.value === "securityDevice") {
      eapiClient("/product/taxonomies/security-device")
        .then(({ data }) => {
          let _systemAdmins = this.updateSystemAdmins()
          this.setState({ securityDev: data.responseData.classificationNodes, systemAdmins: _systemAdmins });
        });
    }
    else if (securityMethod.value === "securityAndMobileDevice") {
      eapiClient("/product/taxonomies/security-mobile-device")
        .then(({ data }) => {
          let _systemAdmins = this.updateSystemAdmins()
          this.setState({ securityDev: data.responseData.classificationNodes, systemAdmins: _systemAdmins });
        });
    }

    var accessControl;
    if (!this.state.currentEchannel.accessControl || !this.state.currentEchannel.accessControl.adminControl) {
      accessControl = { securityMethod, adminControl: {} };
    } else {
      accessControl = { ...this.state.currentEchannel.accessControl, securityMethod };
    }
    this.setState({ currentEchannel: { ...this.state.currentEchannel, accessControl } });
    this.props.unBlockUi();
  }

  handleSecurityDeviceChange = (i, event) => {
    var securityDevice = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    };
    let _systemAdmins = [...this.state.systemAdmins];
    _systemAdmins[i].securityDevices = securityDevice
    this.setState({ systemAdmins: _systemAdmins });
  }

  authorisationLimitsCurrencyChange = (event) => {
    var authorisationLimitsCurrency = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    }
    this.setState({ currentEchannel: { ...this.state.currentEchannel, authorisationLimitsCurrency } });
  }

  onEchannelContactAddition = () => {
    if (this.state.noOfEchannelContacts <= 1) {
      this.setState(prevState => {
        return { noOfEchannelContacts: prevState.noOfEchannelContacts + 1 }
      });
    }
  }

  onEchannelContactDeletion = (index) => {
    let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
    let _delEchannelContact = [...this.state.currentEchannel.eChannelContacts];

    var removeAccount = _delEchannelContact.splice(index, 1)[0];
    let filterDisabledList = this.disableContact.filter(id => id !== removeAccount.id)
    this.disableContact = filterDisabledList

    _eChannelContacts.splice(index, 1);
    this.setState(prevState => {
      return {
        noOfEchannelContacts: prevState.noOfEchannelContacts - 1,
        currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts },
        showAddEchannelContactBtn: true,
        disableEchannelContact: filterDisabledList
      }
    });
  }

  handleEchannelContactChange = (index, contact) => {
    let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];

    if (_eChannelContacts[index]) {
      _eChannelContacts[index].id = contact.id
    } else {
      _eChannelContacts[index] = { id: contact.id }
    }

    this.disableContact.indexOf(contact.id) === -1 && this.disableContact.includes(contact.id)
      ? this.disableContact.push(contact.id)
      : this.disableContact

    this.disableContact[index] = contact.id

    this.setState({
      currentEchannel: {
        ...this.state.currentEchannel,
        eChannelContacts: _eChannelContacts
      },
      disableEchannelContact: this.disableContact
    });
  }

  handleEchannelAddressChange = (index, address) => {
    let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
    if (_eChannelContacts[index]) {
      _eChannelContacts[index].addressId = address.id
    } else {
      _eChannelContacts[index] = { addressId: address.id }
    }
    this.setState({ currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts } });
  }

  // setAttentionFor = (index, event) => {
  //   let _eChannelContacts = [...this.state.currentEchannel.eChannelContacts];
  //   if (_eChannelContacts[index]) {
  //     _eChannelContacts[index].attentionOf = event.target.value;
  //   } else {
  //     _eChannelContacts[index] = { attentionOf: event.target.value };
  //   }
  //   this.setState({ currentEchannel: { ...this.state.currentEchannel, eChannelContacts: _eChannelContacts } });
  // }

  setShouldAddHostToHostContact = (value) => {
    this.setState({ currentEchannel: { ...this.state.currentEchannel, hostToHostContact: value } });
  }

  renderEchannelContactsAccordion = () => {
    let addEchannelContactBtnJsx = "";
    // if(this.state.noOfEchannelContacts >0 && this.state.noOfEchannelContacts < 2) {
    //   addEchannelContactBtnJsx = (<button key="onEchannelContactAddition" className="gdocs-btn-default" onClick={this.onEchannelContactAddition}><i className="icon icon-add"></i>{this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideMultiDropdownlist_designateHTHContact.title)} {this.state.noOfEchannelContacts + 1}</button>);
    // }
    let hostsJsx = [];
    for (var i = 1; i <= this.state.noOfEchannelContacts; i++) {
      hostsJsx.push(
        <div className="echannel-contacts-wrapper" key={i}>
          {i > 1 ? <i className="icon icon-bin delete" role="button" onClick={this.onEchannelContactDeletion.bind(this, i - 1)}></i> : ''}
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideMultiDropdownlist_designateHTHContact.title)} {i}</label>
            </div>
            <div className="form-column">
              {
                (this.props.persons !== undefined && this.props.persons.length > 0) ?
                  (
                    <MultiLineSelect defaultValue={this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                      requiredFields={{
                        "row1": ["title", "firstName", "jobTitle"],
                        "row2": ["emailAddress"],
                        "row3": ["telephoneNumber", "faxNumber"]
                      }}
                      requiredFieldsPrefixes={{
                        "row1": ["", "", "", ""],
                        "row2": [""],
                        "row3": ["Tel", "Fax"]
                      }}
                      flag={true}
                      formatters={{
                        "row1": [
                          ({ title, other }) => title && title.value === 'other' && other ? other : title.value !== 'other' ? title.name : '',
                          ({ firstName, lastName }) => firstName + " " + lastName
                        ],
                        "row3": [
                          ({ telephoneNumber }) => telephoneNumber !== undefined ? telephoneNumber : '',
                          ({ faxNumber }) => faxNumber !== undefined ? faxNumber : ''
                        ]
                      }}
                      salutations={this.state.pageJson.par.aemform_eChannelContacts !== undefined ? this.translations(this.state.pageJson.par.aemform_eChannelContacts.salutation) : ''}
                      disabledOptions={this.disableContact}
                      data={this.props.persons || []}
                      lang={this.props.lang}
                      value={this.state.currentEchannel.eChannelContacts[i - 1] ? this.state.currentEchannel.eChannelContacts[i - 1].id : ''}
                      onEdit={this.handleEchannelContactEditClick.bind(this, this.state.currentEchannel.eChannelContacts[i - 1])}
                      _onChange={this.handleEchannelContactChange.bind(this, i - 1)} />
                  ) : ''
              }
              <PersistLink className="create-link"
                to={'/case-body/create-new-echannel-contact'}
                history={this.props.history}
                state={this.state}
                data={`eChannelContacts${i}`}
              >
                <i className="icon icon-add"></i>
                {this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideMultiDropdownlist_designateHTHContact.createText)}
              </PersistLink>
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideMultiDropdownlist_hostoToHostAddress.title)}</label>
            </div>
            <div className="form-column">
              {
                (this.state.addresses !== undefined && this.state.addresses.length > 0) ?
                  (<SingleLineSelect defaultValue={this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                    requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                    optionsData={this.state.addresses || []}
                    _value={this.state.currentEchannel.eChannelContacts[i - 1] ? this.state.currentEchannel.eChannelContacts[i - 1].addressId : ''}
                    onEdit={this.handleEchannelAddressEditClick} _onChange={this.handleEchannelAddressChange.bind(this, i - 1)} />) : ''
              }
              <PersistLink
                className="create-link"
                to={'/case-body/create-new-echannel-address'}
                history={this.props.history}
                state={this.state}
                data={`addressId${i}`}
              >
                <i className="icon icon-add"></i>
                {this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideMultiDropdownlist_hostoToHostAddress.createText)}
              </PersistLink>
            </div>
          </div>
          {/* <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guidetextbox_forAttenOf.title)}</label>
            </div>
            <div className="form-column">
              <input type="text" value={this.state.currentEchannel.eChannelContacts[i - 1] ? this.state.currentEchannel.eChannelContacts[i - 1].attentionOf : ''} onChange={this.setAttentionFor.bind(this, i - 1)} />
            </div>
          </div> */}
        </div>
      );
    }
    hostsJsx.push(addEchannelContactBtnJsx);

    let echannelConatctsJsx = (
      <NavListAccordion
        lang={this.props.lang.currentLang.lang}
        navAccHeading={`2. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_list.accordian2b)}`}
        status={this.props.currentProductEchannel.statuses.eChannelContacts ? this.props.currentProductEchannel.statuses.eChannelContacts.status : 'incomplete'}
        _onClick={this.getTabIndex.bind(this, '1')}
      >
        <div className="echannel-contact-form">
          <div className="form-column">
            <label>
              {this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideradiobutton_txtERPLink.title)}
            </label>
          </div>
          <div className="form-column">
            <label className="radio-label">
              {this.translateWordForRadio(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideradiobutton_txtERPLink.options)[0].split('=')[1]}
              <Radiobutton
                setInputvalue={this.setShouldAddHostToHostContact}
                name="setShouldAddHostToHostContact"
                _value={this.state.currentEchannel.hostToHostContact}
                value="true"
              />
            </label>
            <label className="radio-label">
              {this.translateWordForRadio(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guideradiobutton_txtERPLink.options)[1].split('=')[1]}
              <Radiobutton
                setInputvalue={this.setShouldAddHostToHostContact}
                name="setShouldAddHostToHostContact"
                _value={this.state.currentEchannel.hostToHostContact}
                value="false"
              />
            </label>
          </div>
          <div className="gdocs-clear-float margin-bottom-30"></div>
          <div className="echannel-contacts-section">
            {
              this.state.currentEchannel.hostToHostContact
                ? hostsJsx
                : ''
            }
          </div>
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button
                className="gdocs-btn-submit"
                onClick={this.onEchannelContactTabDataSubmit}
              >
                {this.translations(this.state.pageEchannelContactJson.guideContainer.rootPanel.items.guidebutton_save.title)}
              </button>
            </div>
          </div>
        </div>
      </NavListAccordion>
    );
    return echannelConatctsJsx;
  }

  onSystemAdminAddition = () => {
    this.setState(prevState => {
      return { noOfSystemAdmins: prevState.noOfSystemAdmins + 1 }
    });
  }

  onSystemAdminDeletion = (index) => {
    let _systemAdmins = [...this.state.systemAdmins];
    let _inputInValidArr = [...this.state.inputInValidArr];
    var _delAccessControlContact = [...this.state.systemAdmins]

    _inputInValidArr.splice(index, 1);
    _systemAdmins.splice(index, 1);

    var removeAccount = _delAccessControlContact.splice(index, 1)[0];
    if (removeAccount !== undefined) {
      let filterDisabledList = this.disableList.filter(id => id !== removeAccount.id)
      this.disableList = filterDisabledList
    }

    this.setState(prevState => {
      return {
        noOfSystemAdmins: prevState.noOfSystemAdmins - 1,
        systemAdmins: _systemAdmins,
        showAddSystemAdminBtn: true,
        inputInValidArr: _inputInValidArr,
        disableAccessControlContact: this.disableList
      }
    });
  }

  handleSystemAdminEditClick = (authorisedPerson, data) => {
    window.sessionStorage.setItem("getCurrentDropDown", data);
    this.saveStateToSessionOnEdit();
    this.props.history.push("/case-body/create-new-echannel-authorised-person/" + authorisedPerson.id);
  }

  handleSystemAdminChange = (index, systemAdmin) => {
    let _systemAdmins = [...this.state.systemAdmins];
    _systemAdmins[index] = { id: systemAdmin.id, dateOfBirth: systemAdmin.dateOfBirth, title: systemAdmin.title };

    this.disableList.indexOf(systemAdmin.id) === -1 && this.disableList.includes(systemAdmin.id)
      ? this.disableList.push(systemAdmin.id)
      : this.disableList

    this.disableList[index] = systemAdmin.id

    this.setState({
      systemAdmins: _systemAdmins,
      disableAccessControlContact: this.disableList
    }, () => { });
  }

  setSysAdminFields = (index, type, event) => {
    let _sysAdmins = [...this.state.systemAdmins];
    if (_sysAdmins[index] === undefined) {
      _sysAdmins[index] = {};
    }
    if (type === "deliveryAddress") {
      _sysAdmins[index].deliveryAddress = event.id;
    } else if (type === "dropdown") {
      _sysAdmins[index][event.target.name] = { name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text, value: event.target.value };
    } else if (type === "autoEntitlementServices") {
      _sysAdmins[index]["autoEntitlementServices"] = event;
    } else if (type === "dateOfBirth") {
      if (_sysAdmins[index].dateOfBirth !== event) {
        _sysAdmins[index].dateOfBirth = event;
      }
    } else {
      _sysAdmins[index][event.target.name] = event.target.value;
    }
    this.setState({ systemAdmins: _sysAdmins });
  }
  validateEmail = (index, event) => {
    let re = /^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{1,}))$/;
    let _inputInValidArr = [...this.state.inputInValidArr];
    if (new RegExp(re).test(String(event.target.value).toLowerCase())) {
      _inputInValidArr[index] = false;
    } else if (event.target.value !== '') {
      _inputInValidArr[index] = true;
    } else {
      _inputInValidArr[index] = false;
    }
    this.setState({ inputInValidArr: _inputInValidArr })

  }

  handleEchannelContactEditClick = (echannelContact) => {
    this.saveStateToSessionOnEdit();
    this.props.history.push("/case-body/create-new-echannel-contact/" + echannelContact.id);
  }

  handleEchannelAddressEditClick = (echannelAddress) => {
    this.saveStateToSessionOnEdit();
    this.props.history.push("/case-body/create-new-echannel-address/" + echannelAddress.id);
  }

  showUserName = () => {
    var echannelBasicData = this.state.basicDetails || this.state.currentEchannel;
    if (echannelBasicData.surAvailable === false) {
      return true;
    }
    else {
      return echannelBasicData.surAvailable && !echannelBasicData.sur;
    }
  }

  // Tooltip
  showSecurityTooltip = () => {
    this.setState({
      showSecurityTooltip: true
    })
  }

  hideSecurityTooltip = () => {
    this.setState({
      showSecurityTooltip: false,
    })
  }
  /* Code fo Date Selector*/
  action(name) {
    return name;
  }

  logAction(name) {
    return this.action;
  }
  setFormElementData = (value, name) => {
  }

  handleBlur = (index, type, event) => {
  }

  handleBackspace = (index, event) => {
    let _sysAdmins = [...this.state.systemAdmins];
    if (_sysAdmins[index].dateOfBirth !== event) {
      _sysAdmins[index].dateOfBirth = '';
    }
    this.setState({ systemAdmins: _sysAdmins });

    console.log(event);
  }
  setFieldValidtionState = (fieldName, fieldValidtionState) => {

    console.log(fieldName);
  }

  handleTelephoneChange = (event, adminIndex) => {
    const { target } = event
    const systemAdmins = [...this.state.systemAdmins]
    const systemAdminObject = Array.isArray(systemAdmins) && systemAdmins.length ? systemAdmins[adminIndex] : {}
    const codes = target.name.includes("CountryCode") ? this.state.telephoneCountryCodes : this.state.telephoneAreaCodes
    if (!isEmptyObject(systemAdminObject)) {
      if (target.name.includes("CountryCode") && target.value !== "+1" && systemAdminObject[target.name.replace("CountryCode", "AreaCode")]) {
        systemAdminObject[target.name.replace("CountryCode", "AreaCode")] = undefined
      }
      systemAdminObject[target.name] = (target.name.includes("CountryCode") || target.name.includes("AreaCode")) ? codes.find(code => code.name === target.value) : target.value
      systemAdmins[adminIndex] = systemAdminObject
      this.setState({ systemAdmins: systemAdmins });
    }
  }

  getTelephoneKey = (prefix = '', postfix = '') => {
    return prefix + postfix
  }

  handleBackspace = (index, event) => {
    let _sysAdmins = [...this.state.systemAdmins];
    if (_sysAdmins[index].dateOfBirth !== event) {
      _sysAdmins[index].dateOfBirth = '';
    }
    this.setState({ systemAdmins: _sysAdmins });
  }

  renderAccessControlAccordion = () => {
    let systemAdminsJsx = [];
    for (let i = 1; i <= this.state.noOfSystemAdmins; i++) {
      systemAdminsJsx.push(
        <div className="system-admin-wrapper" key={i}>
          {
            i > 1
              ? <i className="icon icon-bin delete" role="button" onClick={this.onSystemAdminDeletion.bind(this, i - 1)}></i>
              : ''
          }
          <div className="form-row">
            <div className="form-column">
              <label className="principal-contact">{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.title)} {i}</label>
              {i === 1 ? <label className="principal-contact">{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.contact)}</label> : ''}
            </div>
            <div className="form-column">
              {
                (this.props.persons !== undefined && this.props.persons.length > 0) ?
                  (
                    <MultiLineSelect
                      defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                      requiredFields={{
                        "row1": ["firstName", "jobTitle"],
                        "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                        "row3": []
                      }}
                      requiredFieldsPrefixes={{
                        "row1": ["", "", "", ""],
                        "row2": [""],
                        "row3": ["Tel", "Fax"]
                      }}
                      flag={true}
                      formatters={{
                        "row1": [
                          ({ firstName, lastName }) => firstName + " " + lastName
                        ],
                      }}
                      disabledOptions={this.disableList}
                      data={this.props.persons || []}
                      value={this.state.systemAdmins[i - 1] ? this.state.systemAdmins[i - 1].id : ''}
                      onEdit={this.handleSystemAdminEditClick.bind(this, this.state.systemAdmins[i - 1], `systemAdmins${i}`)}
                      _onChange={this.handleSystemAdminChange.bind(this, i - 1)}
                    />
                  ) : ''
              }
              <PersistLink
                className="create-link"
                to={'/case-body/create-new-echannel-authorised-person'}
                history={this.props.history}
                state={this.state}
                data={`systemAdmins${i}`}
              >
                <i className="icon icon-add"></i>
                {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_sysAdminSignatories.createText)}
              </PersistLink>
            </div>
          </div>
          {
            (this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1].id) ?
              (
                <div className="additional-admin-details-section">
                  <div className="form-row">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_title.title)}</label>
                    </div>
                    <div className="form-column disp-flex">
                      <SimpleDropdown
                        defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_title.text)}
                        value={this.getSystemAdminsTitle(this.state.systemAdmins[i - 1])}
                        _onChange={(event) => {
                          const title = {
                            name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
                            value: event.target.value
                          };
                          const newSystemAdmins = [...this.state.systemAdmins];
                          newSystemAdmins[i - 1].title = title
                          this.setState({ systemAdmins: newSystemAdmins });
                        }}
                        name={`systemAdmins-title-${i - 1}`}
                        options={this.splitOptions(this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_title.options))}
                        optionTextSelector="name"
                        valueSelector="value"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedatepicker_dateOfBirth.title)}</label>
                    </div>
                    <div className="form-column">
                      <DateSelector inputTypeAttr="text"
                        inputPlaceholderAttr='Enter date'
                        properties={{ editType: "date-selector-auto-update" }}
                        onDateSelected={this.logAction('onDateSelected')}
                        extendedPanel={true}
                        dateRangeOptions={[]}
                        showIcon={true}
                        name={this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedatepicker_dateOfBirth.name}
                        value={(this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1].dateOfBirth) ? this.state.systemAdmins[i - 1].dateOfBirth : ''}
                        setdatepicker={this.setSysAdminFields.bind(this, i - 1, "dateOfBirth")}
                        handleBackspace={this.handleBackspace.bind(this, i - 1)}
                        setFieldValidtionState={this.setFieldValidtionState}
                        fieldPrefix={this.props.fieldPrefix}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_emailAddress.title)}</label>
                    </div>
                    <div className="form-column">
                      <input
                        type="text"
                        name="emailAddress"
                        value={(this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1].emailAddress) ? this.state.systemAdmins[i - 1].emailAddress : ''}
                        onChange={this.setSysAdminFields.bind(this, i - 1, "text")}
                        onBlur={this.validateEmail.bind(this, i - 1)}
                      />
                      {
                        (this.state.inputInValidArr[i - 1] !== undefined ?
                          this.state.inputInValidArr[i - 1] ? (
                            <div className="input-error-msg-section">
                              <span className="icon icon-circle-delete-solid"></span>
                              {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_emailAddress.validatePictureClauseMessage)}
                            </div>
                          ) : '' : '')
                      }
                    </div>
                  </div>
                  <div className="form-row hsbcnet-telephone">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.title)}</label>
                    </div>
                    <div className="form-column">
                      <div className="dropdown-combo-wrapper">
                        <div className="combo-dropdown">
                          <TelephoneNumber
                            countryCodes={this.state.telephoneCountryCodes}
                            areaCodes={this.state.telephoneAreaCodes}
                            countryCode={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name,
                              this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.name)]}
                            areaCode={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name,
                              this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.name)]}
                            number={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name]}
                            onChange={(event) => { this.handleTelephoneChange(event, i - 1) }}
                            properties={
                              {
                                countryCode: {
                                  label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.label),
                                  name: this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name,
                                    this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.name)
                                },
                                areaCode: {
                                  label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.label),
                                  name: this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name,
                                    this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.name)
                                },
                                number: {
                                  label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.label),
                                  name: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name
                                },
                                tooltip: {
                                  label: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name,
                                  name: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.name + "_tooltip_" + (i - 1),
                                  data: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_officeTelephoneNumber.tooltip)
                                }
                              }
                            }
                          ></TelephoneNumber>
                        </div>
                        <div className="gdocs-clear-float"></div>
                      </div>
                    </div>
                  </div>
                  <div className="form-row hsbcnet-telephone">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.title)}</label>
                    </div>
                    <div className="form-column dropdown-combo-wrapper">
                      <div className="combo-dropdown">
                        <TelephoneNumber
                          countryCodes={this.state.telephoneCountryCodes}
                          areaCodes={this.state.telephoneAreaCodes}
                          countryCode={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name,
                            this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.name)]}
                          areaCode={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name,
                            this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.name)]}
                          number={this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1][this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name]}
                          onChange={(event) => { this.handleTelephoneChange(event, i - 1) }}
                          properties={
                            {
                              countryCode: {
                                label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.label),
                                name: this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name,
                                  this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_CountryCode.name)
                              },
                              areaCode: {
                                label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.label),
                                name: this.getTelephoneKey(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name,
                                  this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_AreaCode.name)
                              },
                              number: {
                                label: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.label),
                                name: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name
                              },
                              tooltip: {
                                label: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name,
                                name: this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.name + "_tooltip_" + (i - 1),
                                data: this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_mobileNumber.tooltip)
                              }
                            }
                          }
                        ></TelephoneNumber>
                      </div>
                      <div className="gdocs-clear-float"></div>
                    </div>
                  </div>
                  {
                    this.showUserName() ? (
                      <div className="form-row">
                        <div className="form-column">
                          <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_hsbcNetUser.title)}</label>
                        </div>
                        <div className="form-column">
                          <input
                            type="text"
                            name="userName"
                            value={(this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1].userName) ? this.state.systemAdmins[i - 1].userName : ''}
                            onChange={this.setSysAdminFields.bind(this, i - 1, "text")}
                          />
                          <div className="width-535">{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_hsbcNetUser.longDescription)}</div>
                        </div>
                      </div>
                    ) : ''
                  }
                  <div className="form-row">
                    <div className="form-column">
                      <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideradiobutton_enableAutoEntitlement.title)}</label>
                    </div>
                    <div className="form-column">
                      <label>
                        {this.translateWordForRadio(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideradiobutton_enableAutoEntitlement.options)[0].split('=')[1]}
                        <Radiobutton
                          setInputvalue={this.setSysAdminFields.bind(this, i - 1, "autoEntitlementServices")}
                          name={`autoEntitlementServices${i - 1}`}
                          _value={this.state.systemAdmins[i - 1] ? this.state.systemAdmins[i - 1].autoEntitlementServices : ''}
                          value="true"
                        />
                      </label>
                      <label>
                        {this.translateWordForRadio(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideradiobutton_enableAutoEntitlement.options)[1].split('=')[1]}
                        <Radiobutton
                          setInputvalue={this.setSysAdminFields.bind(this, i - 1, "autoEntitlementServices")}
                          name={`autoEntitlementServices${i - 1}`}
                          _value={this.state.systemAdmins[i - 1] ? this.state.systemAdmins[i - 1].autoEntitlementServices : ''}
                          value="false"
                        />
                      </label>
                    </div>
                    <div className="form-row">
                      <div className="form-column">
                        <span>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideradiobutton_enableAutoEntitlement.tooltipText)}</span>
                      </div>
                    </div>
                  </div>

                  {
                    (i === 1 &&
                      this.state.currentEchannel.accessControl !== undefined &&
                      this.state.currentEchannel.accessControl.securityMethod.value !== "mobileDevice") ? (
                      <div className="form-row">
                        <div className="form-column">
                          <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_noOfSecurityDevices.title)}</label>
                        </div>
                        <div className="form-column disp-flex">
                          <SimpleDropdown
                            defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                            value={(this.state.systemAdmins[i - 1] && this.state.systemAdmins[i - 1].securityDevices) ? this.state.systemAdmins[i - 1].securityDevices.value : ''}
                            _onChange={this.handleSecurityDeviceChange.bind(this, i - 1)}
                            options={this.state.securityDev}
                            optionTextSelector={"name"}
                            type="securityDevice"
                          />
                          <div className="marginTop">
                            <i
                              className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
                              data-tooltip={`securityDevices_${i - 1}`}
                              onMouseEnter={this.showSecurityTooltip}
                              onMouseLeave={this.hideSecurityTooltip}
                            >
                            </i>
                          </div>
                          <Tooltip
                            active={this.state.showSecurityTooltip}
                            position="right"
                            arrow="center"
                            parent={`securityDevices_${i - 1}`}
                          >
                            <div className="tooltip-content-hintText">
                              {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_noOfSecurityDevices.tooltipText)}
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    ) : ''
                  }
                  {
                    this.state.currentEchannel.accessControl !== undefined ? (
                      (this.state.currentEchannel.accessControl.securityMethod.value === "securityDevice" || this.state.currentEchannel.accessControl.securityMethod.value === "securityAndMobileDevice") ? (
                        (i === 1) ? (
                          <div className="form-row">
                            <div className="form-column">
                              <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_deliveryAddress.title)}</label>
                            </div>
                            <div className="form-column">
                              {
                                (this.state.addresses !== undefined && this.state.addresses.length > 0)
                                  ? (<SingleLineSelect
                                    defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                                    requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                                    optionsData={this.state.addresses || []}
                                    _value={this.state.systemAdmins[i - 1] ? this.state.systemAdmins[i - 1].deliveryAddress : ''}
                                    onEdit={this.handleEchannelAddressEditClick}
                                    _onChange={this.setSysAdminFields.bind(this, i - 1, "deliveryAddress")}
                                    tooltipText={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_deliveryAddress.tooltipText)}
                                    tooltipId={`deliverAddress_${i - 1}`}
                                  />)
                                  : ''
                              }
                              <PersistLink
                                className="create-link"
                                to={'/case-body/create-new-echannel-address'}
                                history={this.props.history}
                                state={this.state}
                                data={`deliveryAddress${i}`}
                              >
                                <i className="icon icon-add"></i>
                                {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guideMultiDropdownlist_deliveryAddress.createText)}
                              </PersistLink>
                            </div>
                          </div>
                        ) : ''
                      ) : ''
                    ) : ''
                  }
                </div>
              ) : ''
          }
        </div>);
    }
    var setNumberOfAdmin
    if (this.state.currentEchannel.accessControl !== undefined) {
      setNumberOfAdmin = 4;
    }
    if (this.state.noOfSystemAdmins < setNumberOfAdmin) {
      let isDisable = false;
      if (this.state.systemAdmins.length < this.state.noOfSystemAdmins) {
        isDisable = true;
      }
      systemAdminsJsx.push(<button key="onSystemAdminAddition" disabled={isDisable} className="gdocs-btn-default" onClick={this.onSystemAdminAddition}><i className="icon icon-add"></i> {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.slotcontrol_slot1.addText)} {this.state.noOfSystemAdmins + 1}</button>);
    }
    let accessControlAccordionJsx = "";
    accessControlAccordionJsx = (
      <NavListAccordion
        lang={this.props.lang.currentLang.lang}
        navAccHeading={`2. ${this.translations(this.state.pageJson.par.dynamic_accordion_list_list.accordian2a)}`}
        status={this.props.currentProductEchannel.statuses.accessControlAndLimit ? this.props.currentProductEchannel.statuses.accessControlAndLimit.status : ''}
        _onClick={this.getTabIndex.bind(this, '1')}
      >
        <div className="access-control-limit-section">
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                value={this.state.currentEchannel.accessControl ? this.state.currentEchannel.accessControl.adminControl.value : ''}
                _onChange={this.handleAdminControlChange}
                options={this.translateWordForRadio(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.options)}
                mode="aem"
                tooltipText={this.state.currentEchannel.accessControl !== undefined && this.state.currentEchannel.accessControl.adminControl.value === 'soleAuthority' ? this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.tooltipText) : this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.tooltipTextOptional)}
                tooltipId={this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_authority.name}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_securityDevice.title)}</label>
            </div>
            <div className="form-column">
              <SimpleDropdown
                defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                value={this.state.currentEchannel.accessControl ? this.state.currentEchannel.accessControl.securityMethod.value : ''}
                _onChange={this.handleSecurityMethodChange}
                options={this.translateWordForOption(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_securityDevice.options)}
                mode="aem"
              />
            </div>
          </div>
          <hr></hr>
          <div className="echannel-administrators-section">
            <h4>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_hsbcNetUser.echannelAdmin)}</h4>
            <p>{this.translations(this.state.hintTextNo)}</p>
            <div className="system-admin-section">
              {systemAdminsJsx}
              <div className="echannel-currency-list">
                <p>{this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_currencyPaymentAuthorisation.title)}</p>
                {
                  this.state.authorisationLimitsCurrencyOptions !== undefined
                    ? <SimpleDropdown
                      defaultValue={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                      value={this.state.currentEchannel.authorisationLimitsCurrency ? this.state.currentEchannel.authorisationLimitsCurrency.value : ''}
                      _onChange={this.authorisationLimitsCurrencyChange}
                      optionTextSelector={"name"}
                      options={this.state.authorisationLimitsCurrencyOptions}
                      name="authorisationLimitsCurrency"
                      tooltipText={this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidedropdownlist_currencyPaymentAuthorisation.tooltipText)}
                      tooltipId='authorisationLimitsCurrency'
                      type="currency"
                    />
                    : ''
                }
              </div>
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button
                disabled={this.state.inputInValidArr.length !== 0 && this.state.inputInValidArr.includes(true) ? true : false}
                className="gdocs-btn-submit"
                onClick={this.onAccessControlAndLimitTabDataSubmit}
              >
                {this.translations(this.state.pageAccessControlJson.guideContainer.rootPanel.items.guidebutton_save.title)}
              </button>
            </div>
          </div>
        </div>
      </NavListAccordion>
    );
    return accessControlAccordionJsx;
  }

  onProductChecked = (event) => {
    var productsCheckBoxesState = { ...this.state.productsCheckBoxesState };
    productsCheckBoxesState[event.target.name] = event.target.checked;

    var selectedProducts = [...this.state.selectedProducts];
    if (event.target.checked) {
      selectedProducts.push(event.target.name);
    } else {
      selectedProducts.remove(event.target.name);
    }
    this.setState({ selectedProducts, productsCheckBoxesState });
  }
  onProfileLevelProductChecked = (event) => {
    var profileLevelProductsCheckBoxesState = { ...this.state.profileLevelProductsCheckBoxesState };
    profileLevelProductsCheckBoxesState[event.target.name] = event.target.checked;

    var selectedProfileLevelProducts = [...this.state.selectedProfileLevelProducts];
    if (event.target.checked) {
      selectedProfileLevelProducts.push(event.target.name);
    } else {
      selectedProfileLevelProducts.remove(event.target.name);
    }
    this.setState({ selectedProfileLevelProducts, profileLevelProductsCheckBoxesState });
  }

  setReportingAllAccounts = (value, name) => {
    this.setState({ reportingAllAccounts: value });
  }

  onAccountSelected = (event) => {
    var accountsSelectionCheckboxesState = { ...this.state.accountsSelectionCheckboxesState };
    accountsSelectionCheckboxesState[event.target.name] = event.target.checked;

    let selectedAccounts = [...this.state.selectedAccounts];
    if (event.target.checked) {
      selectedAccounts.push(event.target.name);
    } else {
      selectedAccounts.remove(event.target.name);
    }
    this.setState({ selectedAccounts, accountsSelectionCheckboxesState });
  }

  onOtherAccountSelected = (event) => {
    var accountsSelectionCheckboxesState = { ...this.state.accountsSelectionCheckboxesState };
    accountsSelectionCheckboxesState[event.target.name] = event.target.checked;

    let selectedOtherAccounts = [...this.state.selectedOtherAccounts];
    if (event.target.checked) {
      selectedOtherAccounts.push(event.target.name);
    } else {
      selectedOtherAccounts.remove(event.target.name);
    }
    this.setState({
      selectedOtherAccounts,
      accountsSelectionCheckboxesState
    });
  }

  applySettings = () => {
    const payload = new ApplySettingsPayload();
    payload.setPayload(this.state);
    eapiClient("/product/echannel/" + this.state.currentEchannel.id, {
      method: 'PUT',
      data: JSON.stringify(payload)
    })
      .then(({ data }) => {
        // clearing selected list
        this.setState({
          selectedProducts: [],
          selectedOtherProducts: "",
          selectedAccounts: [],
          selectedOtherAccounts: [],
          productsCheckBoxesState: {},
          accountsSelectionCheckboxesState: {},
          // selectedProfileLevelProducts: [],
          // profileLevelProductsCheckBoxesState: {},
          otherAccountLevelProducts: "",
          // otherProfileLevelProducts: ""

        });
        // setting updated other accounts back to state
        this.setState({ currentEchannel: { ...this.state.currentEchannel, otherAccounts: data.responseData.otherAccounts } });
        this.setState({ otherAccountsReportingToEchannel: data.responseData.otherAccounts });
        // fetching accounts reporting to echannel
        eapiClient("/product/account/eChannelReport/" + this.state.currentEchannel.id + "/case/" + this.state.currentEchannel.caseId)
          .then(({ data }) => {
            this.setState({ accountsReportingToEchannel: data.responseData });
          });
      });
  }

  setManualAccountNumberFilling = (value, name) => {
    this.setState({ currentEchannel: { ...this.state.currentEchannel, manualAccountNumberFilling: value } });
  }

  onOtherAccountAddition = () => {
    this.setState(prevState => {
      return { noOfOtherAccounts: prevState.noOfOtherAccounts + 1 }
    });
  }

  onOtherAccountDeletion = (index, accountId) => {
    eapiClient("/product/products/echannels/" + this.state.currentEchannel.id + "/accounts/" + accountId + "/delete-products", {
      method: 'DELETE'
    })
      .then(({ data }) => {
        //let _otherAccounts = [...this.state.currentEchannel.otherAccounts];
        //_otherAccounts.splice(index, 1);
        this.setState(prevState => {
          return {
            noOfOtherAccounts: prevState.noOfOtherAccounts - 1,
            currentEchannel: { ...this.state.currentEchannel, otherAccounts: data.responseData.otherAccounts }
          }
        });
        this.setState({ otherAccountsReportingToEchannel: data.responseData.otherAccounts });
      })
  }

  handleOtherAccountChange = (index, otherAccount) => {
    let _otherAccounts = [...this.state.currentEchannel.otherAccounts];
    if (_otherAccounts[index]) {
      _otherAccounts[index].id = otherAccount.id
    } else {
      _otherAccounts[index] = { id: otherAccount.id }
    }
    this.setState({ currentEchannel: { ...this.state.currentEchannel, otherAccounts: _otherAccounts } });
  }

  handleOtherAccountEditClick = (otherAccount) => {
    var editOtherAccountLink = "/case-body/create-new-echannel-other-account/";
    if (!this.state.currentEchannel.newEchannel) {
      editOtherAccountLink = "/case-body/create-existing-echannel-other-account/";
    }
    this.props.history.push(editOtherAccountLink + otherAccount.id);
  }

  applyEditedSettings = (accountForEditType, editedProducts, selectedOtherProducts, accountsReportingToEchannel) => {
    const payload = new ApplyEditedSettingsPayload();
    payload.setPayload(accountForEditType, editedProducts, selectedOtherProducts, this.state.productsList, this.state.swiftnetProductList, this.state.accountForEdit.id, accountsReportingToEchannel);
    eapiClient("/product/echannel/" + this.state.currentEchannel.id, {
      method: 'PUT',
      data: JSON.stringify(payload)
    })
      .then(({ data }) => {
        // setting updated other accounts back to state
        this.setState({ currentEchannel: { ...this.state.currentEchannel, otherAccounts: data.responseData.otherAccounts } });
        this.setState({ otherAccountsReportingToEchannel: data.responseData.otherAccounts });
        // fetching accounts reporting to echannel
        eapiClient("/product/account/eChannelReport/" + this.state.currentEchannel.id + "/case/" + this.state.currentEchannel.caseId)
          .then(({ data }) => {
            this.setState({ accountsReportingToEchannel: data.responseData });
          });
      });
  }

  editProductsList = (account, accountForEditType, event) => {
    var accountForEdit;
    if (accountForEditType === 'gdocs-account') {
      accountForEdit = account;
    } else {
      accountForEdit = account;
    }

    this.setState({
      showEditProductEnablementDialog: true,
      accountForEdit,
      accountForEditType
    });
  }

  getReadOnlyProductsLinkTextForOtherAccounts = (otherAccount) => {
    var part1 = '',
      part2 = '',
      finalLinkText = '';

    if ((otherAccount.productEnablements === undefined ||
      otherAccount.productEnablements.length === 0) &&
      (otherAccount.otherProductEnablements === undefined ||
        otherAccount.otherProductEnablements === '')) {
      finalLinkText = `${'0'} ${this.state.pageProductEnablementJson !== undefined ? this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.prodEnable) : 'product enabled'}`
    } else {
      if (otherAccount.productEnablements) {
        part1 = otherAccount.productEnablements
          .map(product => product.description)
          .join(", ");
      }
      part2 = otherAccount.otherProductEnablements ? (part1 !== '' ? `, ${otherAccount.otherProductEnablements}` : otherAccount.otherProductEnablements) : '';
      finalLinkText = part1 + part2;
    }
    return finalLinkText;
  }

  getReadOnlyProductsLinkTextForAccounts = (account, currentEchannelId) => {
    // if(account.eChannelReporting.length >0 ){}
    var { productEnablements = [], otherProductEnablements } = account.eChannelReporting !== undefined && account.eChannelReporting.length > 0 ? account.eChannelReporting.find(_ecr => _ecr.eChannelId === currentEchannelId) : '';
    var part1, part2 = "";
    if (productEnablements.length === 0 && (otherProductEnablements === undefined || otherProductEnablements === "")) {
      return `${'0'} ${this.state.pageProductEnablementJson !== undefined ? this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.prodEnable) : 'product enabled'}`;
    } else {
      part1 = productEnablements.map(product => product.description).join(", ");
      part2 = otherProductEnablements ? (part1 !== "" ? `, ${otherProductEnablements}` : otherProductEnablements) : '';
      return part1 + part2;
    }
  }

  checkReportingToCFF = () => {
    if (Array.isArray(this.props.productDetails.cashFlowForecasting) && this.props.productDetails.cashFlowForecasting.length) {
      const { productId } = this.props.match.params;
      const flag = this.props.productDetails.cashFlowForecasting.map(product => product.eChannelReporting.find(eChannelId => eChannelId === productId)).filter(el => !!el).length
      return Boolean(flag)
    }
  }

  renderProductEnablementForm() {
    const currentEchannelId = this.state.currentEchannel.id;
    const currentEchannelType = this.state.currentEchannel && this.state.currentEchannel.eChannelType && this.state.currentEchannel.eChannelType.value;
    let productList = this.state.productsList;
    let profileLevelProducts = this.state.profileLevelProducts ? this.state.profileLevelProducts : [];
    if (currentEchannelType === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:swiftNet') {
      if (this.state.swiftnetProductList) { productList = productList.concat(this.state.swiftnetProductList); }
    }

    let createOtherAccountLink = "/case-body/create-new-echannel-other-account";
    if (!this.state.currentEchannel.newEchannel) {
      createOtherAccountLink = "/case-body/create-existing-echannel-other-account";
    }

    let otherAccountsJsx = this.state.otherAccountsReportingToEchannel && this.state.otherAccountsReportingToEchannel.length > 0 ? (
      this.state.otherAccountsReportingToEchannel.map((otherAccount, i) => (
        <div className="account-wrapper existing-account" key={i}>
          <i className="icon icon-bin delete" role="button" onClick={this.onOtherAccountDeletion.bind(this, i, otherAccount.id)}></i>
          {
            [
              <p
                key={`account-details-${otherAccount.accountNumber}`}
                className="account-details"
              >
                {`${otherAccount.accountNumber}, ${otherAccount.country.name}, ${otherAccount.currency.name}`}
              </p>,
              <p
                key={`bank-details-${otherAccount.accountNumber}`}
                className="bank-details"
              >
                {`${otherAccount.bankName !== undefined ? `${otherAccount.bankName},` : ''}${otherAccount.branchCode}`}
              </p>,
              <p key={`entity-details-${otherAccount.accountNumber}`}
                className="entity-details">
                {(this.state.currentEchannel.newEchannel === true ? (otherAccount.otherAccountHolder === 'true' && otherAccount.otherAccountHolder !== undefined) ? otherAccount.tradingName :
                  (otherAccount.otherAccountHolder !== undefined ?
                    otherAccount.tradingName : otherAccount.accountHolder.name)
                  : otherAccount.tradingName)}
              </p>
            ]
          }
          <p className="read-only-product-list">
            <a
              onClick={this.editProductsList.bind(this, otherAccount, 'third-party-account')}
            >
              {this.getReadOnlyProductsLinkTextForOtherAccounts(otherAccount)}
            </a>
          </p>
        </div>
      ))
    ) : [];

    return (
      <div>
        {this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_profileLevelProductsCFF && this.checkReportingToCFF() ?
          <div className="profile-level-products-cff">
            <label>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_profileLevelProductsCFF.title)}</label>
            <input
              type="text"
              id="profileLevelProductsCFF"
              name="profileLevelProductsCFF"
              value={this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_profileLevelProductsCFF._value)}
              disabled
            ></input>
          </div>
          : null}
        {this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCAPI &&
          profileLevelProducts.length > 1 && <div>
            <fieldset>
              <legend>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_profileLevelProductsCFF.title)}</legend>
              <div className="product-list">
                {
                  (this.state.profileLevelProducts).map((item, index) => (<div className='checkbox-container' key={item.id}>
                    <Checkbox
                      onChange={this.onProfileLevelProductChecked}
                      id={item.id}
                      name={item.id}
                      checked={this.state.profileLevelProductsCheckBoxesState[item.id]}
                      controlled
                    />
                    <label
                      htmlFor={item.id}
                      className="product-enablement-text"
                    >
                      {`${item.name} (${item.description})`}
                    </label>
                  </div>)
                  )

                }
              </div>

            </fieldset>
            <div className="other-products-list-section">
              <label>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.title)}</label>
              <section className="gdocs-display-flex gdocs-align-items-center">
                <input
                  type="text"
                  id="otherProfileLevelProducts"
                  name="otherProfileLevelProducts"
                  // value={this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_profileLevelProductsCFF._value)}
                  value={this.state.otherProfileLevelProducts}
                  onChange={(event) => this.setNotListedOtherProfileProducts(event)}
                ></input>
              </section>
            </div></div>}
        {
          productList.length > 1 ?
            <fieldset>
              <legend>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidecheckbox_providedServices.title)}</legend>
              <div className="product-list">
                {
                  (productList.slice(0, 3)).map((item, index) => (<div className='checkbox-container' key={item.id}>
                    <Checkbox
                      onChange={this.onProductChecked}
                      id={item.id}
                      name={item.id}
                      checked={this.state.productsCheckBoxesState[item.id]}
                      controlled
                    />
                    <label
                      htmlFor={item.id}
                      className="product-enablement-text"
                    >
                      {`${item.name} (${item.description})`}
                    </label>
                  </div>)
                  )
                }
              </div>
              <div className="product-list">
                {
                  (productList.slice(3, 6)).map((item, index) => (<div className='checkbox-container' key={item.id}>
                    <Checkbox
                      onChange={this.onProductChecked}
                      id={item.id}
                      name={item.id}
                      checked={this.state.productsCheckBoxesState[item.id]}
                      controlled
                    />
                    <label
                      htmlFor={item.id}
                      className="product-enablement-text"
                    >
                      {`${item.name} (${item.description})`}
                    </label>
                  </div>)
                  )
                }
              </div>
              <div className="product-list">
                {(productList.slice(6, 9)).map((item, index) => (<div className='checkbox-container' key={item.id}>
                  <Checkbox
                    onChange={this.onProductChecked}
                    id={item.id}
                    name={item.id}
                    checked={this.state.productsCheckBoxesState[item.id]}
                    controlled
                  />
                  <label
                    htmlFor={item.id}
                    className="product-enablement-text"
                  >
                    {`${item.name} (${item.description}) `}
                  </label>
                </div>)
                )}
              </div>
            </fieldset> : ''
        }
        <div className="gdocs-clear-float"></div>
        {
          this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value === ECHANNEL_HSBCAPI && <div className="other-products-list-section">
            <label>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.title)}</label>
            <section className="gdocs-display-flex gdocs-align-items-center">
              {/* <input
                type="text"
                id="otherAccountLevelProducts"
                name="otherAccountLevelProducts"
                value={this.state.otherAccountLevelProducts}
                onChange={(event) => this.setNotListedOtherProducts(event)}
              ></input> */}

              <section class="selected-otherproducts-section disabled">
                {this.state.selectedOtherProducts}
              </section>
              <section className="select-others-link-container"
                role="button"
                tabindex="0"
              >
                <span className="select-others-link-plus-icon">+</span>
                <a
                  className="select-others-link"
                  onClick={() => { this.setState({ showOtherProductsListDialog: true }) }}
                >
                  {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.selectText)}
                </a>
              </section>


            </section>

          </div>}
        {
          this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value !== ECHANNEL_HSBCAPI && <div className="other-products-list-section">
            <label>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.title)}</label>
            <section className="gdocs-display-flex gdocs-align-items-center">
              <section class="selected-otherproducts-section disabled">
                {this.state.selectedOtherProducts}
              </section>
              <section className="select-others-link-container"
                role="button"
                tabindex="0"
              >
                <span className="select-others-link-plus-icon">+</span>
                <a
                  className="select-others-link"
                  onClick={() => { this.setState({ showOtherProductsListDialog: true }) }}
                >
                  {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.selectText)}
                </a>
              </section>
            </section>
          </div>
        }
        {
          this.state.currentEchannelType && this.state.currentEchannelType.eChannelType && this.state.currentEchannelType.eChannelType.value ===
          ECHANNEL_HSBCAPI &&
          <div className="api-info-static-text">
            <span>
              {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.staticText_API.text)}
            </span>
          </div>
        }
        <div className="apply-settings-section">
          <fieldset>
            <legend>{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.title)}</legend>
            <div>
              <label className="radio-label">
                {this.translateWord(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.options)[0]}
                <Radiobutton
                  setInputvalue={this.setReportingAllAccounts}
                  name="reportingAllAccounts"
                  _value={this.state.reportingAllAccounts}
                  value="true"
                />
              </label>
              <label className="radio-label">
                {this.translateWord(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.options)[1]}
                <Radiobutton
                  setInputvalue={this.setReportingAllAccounts}
                  name="reportingAllAccounts"
                  _value={this.state.reportingAllAccounts}
                  value="false"
                />
              </label>
            </div>
          </fieldset>
          {
            this.state.reportingAllAccounts === false ? (
              <div className="accounts-selection-section">
                {
                  this.state.accountsReportingToEchannel.map(account => (
                    <div className="account-wrapper" key={account.id}>
                      <Checkbox onChange={this.onAccountSelected} id={account.id} name={account.id} checked={this.state.accountsSelectionCheckboxesState[account.id]} controlled />
                      <label className="product-enablement-text">{`${account.accountType ? account.accountType.name : account.accountNumber},
                             ${account.country.name} ${account.currency ? `, ${account.currency.name}` : ''}`}</label>
                    </div>
                  ))
                }
                {
                  this.state.currentEchannel.otherAccounts ? this.state.currentEchannel.otherAccounts.map(account => (
                    <div className="account-wrapper" key={account.id}>
                      <Checkbox onChange={this.onOtherAccountSelected} id={account.id} name={account.id} checked={this.state.accountsSelectionCheckboxesState[account.id]} controlled />
                      <label className="product-enablement-text">{`${account.accountNumber}, ${account.bankName}, ${account.country.name}`}</label>
                    </div>
                  )) : this.translateWord(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_applySettings.options)[2]

                }
              </div>
            ) : ''
          }
          <button className="gdocs-btn-default" onClick={this.applySettings}>
            {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidebutton_apply.title)}
          </button>
        </div>
        <hr></hr>
        <div className="accounts-reporting-to-echannel-section">
          {
            this.state.accountsReportingToEchannel.map(account => (
              <div className={`account-wrapper ${account.accountType !== undefined ? "new-account" : "existing-account"}`} key={account.id}>
                <p className="account-details">{`${account.accountType !== undefined ? account.accountType.name : account.accountNumber}, ${account.country.name} ${account.currency ? `, ${account.currency.name}` : ''}`}</p>
                {account.accountType ?
                  ''
                  : (<p className="entity-details">{`${account.bankName !== undefined && account.bankName.trim() !== "" ? `${account.bankName},` : `${account.hsbcAccount ? `${account.hsbcAccount.toUpperCase()},` : ''}`} ${account.branchCode !== undefined ? account.branchCode : ''}`}</p>)
                }
                <p className="entity-details">{`${account.accountHolder.name} ${account.accountType ? `(${account.accountTitle ? account.accountTitle + ', ' : ''}${account.tempRefrenceId})` : ''}`}</p>
                <p className="read-only-product-list">
                  <a onClick={this.editProductsList.bind(this, account, 'gdocs-account')}>
                    {this.getReadOnlyProductsLinkTextForAccounts(account, currentEchannelId)}
                  </a>
                </p>
              </div>
            ))
          }
          {otherAccountsJsx}
          <PersistLink
            className="create-link gdocs-btn-default"
            to={createOtherAccountLink}
            history={this.props.history}
            state={this.state}
          >
            <i className="icon icon-add"></i>
            {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidebutton_apply.text)}
          </PersistLink>
          <p className="note">
            {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidebutton_apply.helpText)}
          </p>
        </div>
        <hr></hr>
        <fieldset>
          <legend className="account-number-permission">
            {this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_fillAccountNumbers.title)}
          </legend>
          <label
            className="radio-label"
          >
            {this.translateWordForRadio(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_fillAccountNumbers.options)[0].split('=')[1]}
            <Radiobutton
              setInputvalue={this.setManualAccountNumberFilling}
              name="manualAccountNumberFilling"
              _value={this.state.currentEchannel.manualAccountNumberFilling}
              value="true"
            />
          </label>
          <label
            className="radio-label"
          >
            {this.translateWordForRadio(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guideradiobutton_fillAccountNumbers.options)[1].split('=')[1]}
            <Radiobutton
              setInputvalue={this.setManualAccountNumberFilling}
              name="manualAccountNumberFilling"
              _value={this.state.currentEchannel.manualAccountNumberFilling}
              value="false"
            />
          </label>
        </fieldset>
      </div >
    )
  }

  toNextpage = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state, this.checkReportingToCFF());
    this.props.reSetEChannelActiveTabIndex();
    var { productId } = this.props.match.params;

    eapiClient("/product/echannel/" + productId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.history.push('/case-body');
      });
  }

  getTabIndex = (index) => {
    if (!(index === this.props.displayTabIndex))
      this.props.setEChannelActiveTabIndex(index);
  }

  splitOptions = (options = []) => {
    return convertStringToArrayForOption(options).map(function (option) {
      const [value = '', name = '',] = option.split('=');
      return { name, value };
    });
  }

  getSystemAdminsTitle = (admin = {}) => {
    let titleValue = ''
    if (admin.title) {
      titleValue = admin.title.value
    } else if (this.props.persons) {
      const { title } = this.props.persons.find(p => p.id === admin.id) || {}
      if (title) {
        titleValue = title.value
      }
    }
    return titleValue
  }

  getConvertEchannelModalJson = async () => {
    const { data } = await eapiClient("/aemData/formData/json_modal-convert-echannel")
    this.setState({ modalConvertEchannelJson: data })
  }
  setNotListedOtherProducts = (e) => {
    this.setState({
      otherAccountLevelProducts: e.target.value
    })
  }
  setNotListedOtherProfileProducts = (e) => {

    this.setState({
      otherProfileLevelProducts: e.target.value
    })
  }

  render() {
    let accordianList;
    if (this.state.pageJson) {
      accordianList = this.state.pageJson.par.dynamic_accordion_list_list;
    }
    let productEnablementIndex = (this.state.currentEchannel.id && this.state.currentEchannel.newEchannel) ? 3 : 2;
    document.title = (this.state.currentEchannel.id &&
      this.state.pageJson !== undefined)
      ? `${"Product Requests"} - ${"Review Product"} - ${`${this.state.currentEchannel && this.state.currentEchannel.eChannelType && this.state.currentEchannel.eChannelType.name + ","} ${this.state.currentEchannel.country.name}
              (${this.state.currentEchannel.newEchannel
        ? this.translations(this.state.pageJson.par.page_title_mainTitle.new)
        : `${this.translations(this.state.pageJson.par.page_title_mainTitle.existing)}:${this.state.currentEchannel.eChannelId}`})`} - ${'HSBC GLCM'}`
      : `${"Product Requests"}-  - ${"Review Product"} -${"Echannels"} - ${'HSBC GLCM'}`;
    return ((this.state.currentEchannel.id &&
      this.state.pageJson !== undefined && this.state.pageProductEnablementJson !== undefined
      && this.state.pageAccessControlJson !== undefined && this.state.pageEchannelContactJson !== undefined) ? (
      <div className="product-echannel-container">
        <div className="pannel-heading-container">
          <h2 className="pannel-heading">
            {`${this.state.currentEchannel && this.state.currentEchannel.eChannelType && this.state.currentEchannel.eChannelType.name + "," || ""} ${this.state.currentEchannel.country.name} 
                    (${this.state.currentEchannel.newEchannel
                ? this.translations(this.state.pageJson.par.page_title_mainTitle.new)
                : `${this.translations(this.state.pageJson.par.page_title_mainTitle.existing)}:${this.state.currentEchannel.eChannelId}`})`}</h2>
          <p className="pannel-sub-heading">
            {`${this.state.currentEchannel.profileOwner.name} ${this.state.currentEchannel.newEchannel && this.state.currentEchannel.tempRefrenceId ?
              "(" + this.state.currentEchannel.tempRefrenceId + ")" : ''}`}
          </p>
          <p className="optional-text">{this.translations(this.state.pageJson.par.page_title_mainTitle.descriptionText)}</p>
        </div>
        <div className="gdocs-clear-float"></div>

        <NavListAccordionWrapper open={this.props.displayTabIndex}>
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`1. ${this.translations(accordianList.accordian1)}`}
            status={this.props.currentProductEchannel && this.props.currentProductEchannel.statuses && this.props.currentProductEchannel.statuses.basicDetails && this.props.currentProductEchannel.statuses.basicDetails.status}
            _onClick={this.getTabIndex.bind(this, '0')}
          >
            <div>{this.renderBasicDetailsForm()}</div>
          </NavListAccordion>
          {
            (this.state.currentEchannel.newEchannel && this.state.currentEchannel.eChannelType && this.state.currentEchannel.eChannelType.value === "urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet")
              ? this.renderAccessControlAccordion()
              : null
          }
          {
            (this.state.currentEchannel.newEchannel && this.state.currentEchannel.eChannelType && this.state.currentEchannel.eChannelType.value !== "urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet")
              ? this.renderEchannelContactsAccordion()
              : null
          }
          <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`${productEnablementIndex}. ${this.translations(accordianList.accordian3)}`}
            status={this.props.currentProductEchannel && this.props.currentProductEchannel.statuses && this.props.currentProductEchannel.statuses.productEnablements && this.props.currentProductEchannel.statuses.productEnablements.status}
            _onClick={this.getTabIndex.bind(this, productEnablementIndex - 1)}
          >
            <div className="product-enablement-section form-section">
              <div>
                {
                  this.renderProductEnablementForm()
                }
              </div>
              <div className="gdocs-clear-float"></div>
              <div key="buttons-wrapper" className="form-buttons-save-section">
                <div className="form-buttons-wrapper">
                  <button
                    className="gdocs-btn-submit"
                    onClick={this.onProductEnablementTabDataSubmit}
                  >{this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidebutton_save.text)}</button>
                </div>
              </div>
            </div>

          </NavListAccordion>
        </NavListAccordionWrapper>
        <div className="save-and-return">
          <button
            onClick={this.toNextpage}
            className='gdocs-btn-primary'
          >
            {this.translations(this.state.pageJson.par.button_saveAndReturn.text)}
          </button>
        </div>
        <OtherProductsListModal
          redBtn={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson.par.title.otherButtonText) : null}
          modalTitle={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson.par.title.modalTitle) : ''}
          showDialog={this.state.showOtherProductsListDialog}
          otherProductsList={this.state.otherProductsList}
          toggleDialog={this.toggleDialog}
          bsClass="gdocs-other-products-list-dialog"
          lang={this.props.lang}
          handleOtherProductsSubmit={this.handleOtherProductsSubmit}
          selectedOtherProducts={this.state.selectedOtherProducts}
          cancelBtn={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson.par.title.otherCancelButtonText) : ''}
          unlistedotherProductsInputLabel={this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_unlistedOtherproducts.title)}
          productsList={this.state.productsList}
        />
        <EditProductEnablementModal
          cancelBtn={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson["sticky-footer-btn4"].text) : ''}
          applyBtn={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson["sticky-footer-btn3"].text) : ''}
          modalTitle={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson.par.title.title) : ''}
          showDialog={this.state.showEditProductEnablementDialog}
          otherLabel={this.state.editProductEnablementModalJson ? this.translations(this.state.editProductEnablementModalJson.par.title.other) : ''}
          productsList={this.state.productsList}
          swiftnetProductList={this.state.swiftnetProductList}
          toggleDialog={this.toggleDialog}
          accountForEdit={this.state.accountForEdit}
          accountsReportingToEchannel={this.state.accountsReportingToEchannel}
          accountForEditType={this.state.accountForEditType}
          onApplyEnabelmentsToProduct={this.applyEditedSettings}
          currentEchannel={this.state.currentEchannel}
          bsClass="gdocs-edit-product-enablements-dialog"
          lang={this.props.lang}
          resetSelectedOtherProducts={() => this.setState({ selectedOtherProducts: '' })}
          selectedOtherProducts={this.state.selectedOtherProducts}
          otherProductsList={this.state.otherProductsList}
          addOtherPorductsLinkText={this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_other.selectText)}
          unlistedotherProductsInputLabel={this.translations(this.state.pageProductEnablementJson.guideContainer.rootPanel.items.guidetextbox_unlistedOtherproducts.title)}
        />
        {this.state.modalConvertEchannelJson && <ConvertEchannelModal convertEchannelModal={this.state.convertEchannelModal} toggleConvertEchannelModal={() => { this.setState({ convertEchannelModal: { show: false } }) }}
          handleConvertEchannel={() => { this.props.history.push("/case-body/convert-echannel", { currentEchannel: { ...this.state.currentEchannel, newEchannel: this.state.convertEchannelModal.newEchannel } }) }}
          modalConvertEchannelJson={this.state.modalConvertEchannelJson} translations={this.translations}
        ></ConvertEchannelModal>}
      </div>
    )
      : null
    );
  }
}

const ConvertEchannelModal = (props) => {
  const { convertEchannelModal, toggleConvertEchannelModal, handleConvertEchannel, modalConvertEchannelJson = { par: {} }, translations } = props
  const renderModalJson = !convertEchannelModal.newEchannel ? modalConvertEchannelJson.par.modal_newEchannel : modalConvertEchannelJson.par.modal_existingEchannel
  return (
    <Modal show={convertEchannelModal && convertEchannelModal.show} onClose={toggleConvertEchannelModal} className="gdocs-convert-echannel-modal">
      <ModalHeader>
        <div>{translations(renderModalJson.modalTitle)} </div>
      </ModalHeader>
      <ModalBody>
        <div className='gdocs-mbottom-20'>
          {translations(renderModalJson.par1)}
        </div>

      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default gdocs-mr-1rem" onClick={toggleConvertEchannelModal}>{translations(renderModalJson.cancelText)}</button>
        <button className="gdocs-btn-primary" onClick={handleConvertEchannel}>{translations(renderModalJson.redBtn)}</button>
      </ModalFooter>
    </Modal>
  )
}

// Basic Detail
class BasicDetail {
  constructor() {
    this.data = {}
  }

  setBasicDetailPayload(state, props) {
    var { basicDetails } = state;
    var { cases } = props;

    this.data = { ...basicDetails };
    this.data.eChannelType = basicDetails.eChannelType !== undefined && basicDetails.eChannelType.name !== undefined ? basicDetails.eChannelType : state.currentEchannel.eChannelType;
    if (basicDetails && basicDetails.newEchannel === false) {
      const { other } = basicDetails;
      if (!other) {
        this.data.profileOwner = { ...basicDetails.profileOwnerInPack };
        this.data.profileOwnerInPack = undefined;
        this.data.otherProfileOwner = undefined;


      } else {
        this.data.profileOwner = { ...basicDetails.otherEntityProfileOwner };
        this.data.profileOwnerInPack = undefined;
        this.data.otherProfileOwner = basicDetails.otherEntityProfileOwner !== undefined ? basicDetails.otherEntityProfileOwner.value === 'other' ? basicDetails.otherProfileOwner : undefined : basicDetails.otherProfileOwner;;
        this.data.otherEntityProfileOwner = undefined;
      }
    }
  }
}

// Echannel Contact
class EchannelContact {
  constructor() {
    this.data = {}
  }

  setEchannelContactPayload(state, props) {
    var { currentEchannel, caseId } = state;
    if (currentEchannel.newEchannel) {
      this.data.caseId = caseId;
      this.data.eChannelContacts = currentEchannel.eChannelContacts;
      this.data.hostToHostContact = currentEchannel.hostToHostContact;
    }
  }
}
// Access control limit
class AccessControlLimit {
  constructor() {
    this.data = {}
  }

  setAccessControlLimitPayload(state, props) {
    var { basicDetails, currentEchannel, systemAdmins, caseId } = state;

    if (currentEchannel.newEchannel) {
      this.data.caseId = caseId;
      this.data.accessControl = currentEchannel.accessControl;
      this.data.authorisationLimitsCurrency = currentEchannel.authorisationLimitsCurrency;
      if (basicDetails.sur === true || currentEchannel.sur === true) {
        this.data.eChannelAdmins = systemAdmins.map(admin => {
          return {
            ...admin,
            userName: undefined
          }
        });
      } else {
        this.data.caseId = caseId;
        this.data.eChannelAdmins = systemAdmins;
      }
    }
  }
}

// Product Enablement
class ProductEnablement {
  constructor() {
    this.data = {}
  }

  setProductEnablementPayload(state, props, echannelReportedToCFF) {
    var { currentEchannel, caseId } = state;
    this.data.caseId = caseId
    if (echannelReportedToCFF) {
      this.data.profileLevelProduct = CFF
    }
    this.data.otherAccounts = currentEchannel.otherAccounts;
    this.data.manualAccountNumberFilling = currentEchannel.manualAccountNumberFilling;
    this.data.otherProfileLevelProducts = state.otherProfileLevelProducts;
    if (state.selectedProfileLevelProducts.length > 0) {
      this.data.profileLevelProducts = state.profileLevelProducts.reduce((acc, product) => {
        if (state.selectedProfileLevelProducts.indexOf(product.id) !== -1) {
          acc.push(product);
        }
        return acc;
      }, []);
    }
  }
}

// Final payload
class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }

  setPayload(state, echannelReportedToCFF) {
    var { basicDetails, currentEchannel, systemAdmins } = state;
    this.data = { ...basicDetails };

    if (echannelReportedToCFF) {
      this.data.profileLevelProduct = CFF
    }
    if (basicDetails && basicDetails.newEchannel === false) {
      const { other } = basicDetails;
      if (!other) {
        this.data.profileOwner = { ...basicDetails.profileOwnerInPack };
        this.data.profileOwnerInPack = undefined;
        this.data.otherProfileOwner = undefined;
      } else {
        this.data.profileOwner = { ...basicDetails.otherEntityProfileOwner };
        this.data.profileOwnerInPack = undefined;
        this.data.otherProfileOwner = basicDetails.otherEntityProfileOwner !== undefined ? basicDetails.otherEntityProfileOwner.value === 'other' ? basicDetails.otherProfileOwner : undefined : basicDetails.otherProfileOwner;;
        this.data.otherEntityProfileOwner = undefined;
      }
    }
    if (currentEchannel.newEchannel) {
      this.data.eChannelContacts = currentEchannel.eChannelContacts;
      this.data.accessControl = currentEchannel.accessControl;
      this.data.authorisationLimitsCurrency = currentEchannel.authorisationLimitsCurrency;
      if (basicDetails.sur === true || currentEchannel.sur === true) {
        this.data.eChannelAdmins = systemAdmins.map(admin => {
          return {
            ...admin,
            userName: undefined
          }
        });
      } else {
        this.data.eChannelAdmins = systemAdmins;
      }
      this.data.hostToHostContact = currentEchannel.hostToHostContact;
    }
    this.data.otherAccounts = currentEchannel.otherAccounts;
    this.data.manualAccountNumberFilling = currentEchannel.manualAccountNumberFilling;
    this.data.eChannelType = basicDetails.eChannelType !== undefined && basicDetails.eChannelType.name !== undefined ? basicDetails.eChannelType : currentEchannel.eChannelType;
    this.data.otherProfileLevelProducts = state.otherProfileLevelProducts;
    if (state.selectedProfileLevelProducts.length > 0) {
      this.data.profileLevelProducts = state.profileLevelProducts.reduce((acc, product) => {
        if (state.selectedProfileLevelProducts.indexOf(product.id) !== -1) {
          acc.push(product);
        }
        return acc;
      }, []);
    }
    else {
      this.data.profileLevelProducts = []
    }

  }
}

class ApplySettingsPayload {
  constructor() {
    this.productEnablement = {};
  }

  setPayload({ currentEchannel, selectedAccounts, selectedOtherAccounts, selectedProducts, selectedOtherProducts, productsList, swiftnetProductList, reportingAllAccounts, accountsReportingToEchannel, otherAccountLevelProducts }) {
    if (reportingAllAccounts === false) {
      if (selectedAccounts.length > 0) {
        let accIdies = [];
        let glsReportedAccIdies = [];
        let achReportedAccIdies = [];
        for (let acc of selectedAccounts) {
          let includeAccInAccountIdies = true;
          let glsAccount, achAccount;
          for (let accRpt of accountsReportingToEchannel) {
            if (accRpt.id == acc && (accRpt.hasOwnProperty('echannelReportedGlsId') || accRpt.hasOwnProperty('echannelReportedAchCreditId'))) {
              includeAccInAccountIdies = false;
              if (accRpt.hasOwnProperty('echannelReportedGlsId')) {
                glsAccount = Object.assign({}, accRpt);
              } else if (accRpt.hasOwnProperty('echannelReportedAchCreditId')) {
                achAccount = Object.assign({}, accRpt);
              }
              break;
            }
          }
          if (includeAccInAccountIdies) {
            accIdies.push(acc);
          } else if (!includeAccInAccountIdies && (glsAccount || achAccount)) {
            if (glsAccount) {
              glsReportedAccIdies.push({
                glsId: glsAccount.echannelReportedGlsId,
                accountId: glsAccount.id
              })
            } else if (achAccount) {
              achReportedAccIdies.push({
                achCreditId: achAccount.echannelReportedAchCreditId,
                accountId: achAccount.id
              })
            }
          }
        }
        if (accIdies && accIdies.length > 0) {
          this.productEnablement.accountIdies = accIdies;
        }
        if (glsReportedAccIdies && glsReportedAccIdies.length > 0) {
          this.productEnablement.glsEchannelMap = glsReportedAccIdies;
        }
        if (achReportedAccIdies && achReportedAccIdies.length > 0) {
          this.productEnablement.achCreditEchannelMap = achReportedAccIdies;
        }
      }
      if (selectedOtherAccounts.length > 0) {
        this.productEnablement.otherAccountIdies = selectedOtherAccounts;
      }
    } else if (reportingAllAccounts) {
      let createGLSMap = false, createACHMap = false;
      this.productEnablement.accountIdies = accountsReportingToEchannel.map(account => {
        if (!account.hasOwnProperty("echannelReportedGlsId") && !account.hasOwnProperty("echannelReportedAchCreditId")) {
          return account.id;
        } else {
          if (account.hasOwnProperty("echannelReportedGlsId")) {
            createGLSMap = true;
          } else if (account.hasOwnProperty("echannelReportedAchCreditId")) {
            createACHMap = true;
          }
        }
      }).filter(accFilter => {
        if (accFilter) {
          return accFilter
        }
      });

      //Adding GLS product map
      if (createGLSMap) {
        this.productEnablement.glsEchannelMap = accountsReportingToEchannel.map((acc) => {
          if (acc.hasOwnProperty("echannelReportedGlsId")) {
            let accReportedToGls = {
              glsId: acc.echannelReportedGlsId,
              accountId: acc.id
            }
            return accReportedToGls;
          }
        }).filter(accFilter => {
          if (accFilter) {
            return accFilter
          }
        })
      }
      //Adding ACH product map
      if (createACHMap) {
        this.productEnablement.achCreditEchannelMap = accountsReportingToEchannel.map((acc) => {
          if (acc.hasOwnProperty("echannelReportedAchCreditId")) {
            let accReportedToAch = {
              achCreditId: acc.echannelReportedAchCreditId,
              accountId: acc.id
            }
            return accReportedToAch;
          }
        }).filter(accFilter => {
          if (accFilter) {
            return accFilter
          }
        })
      }

      this.productEnablement.otherAccountIdies = currentEchannel.otherAccounts !== undefined ? currentEchannel.otherAccounts.map(otherAccount => {
        return otherAccount.id;
      }) : [];
    }

    productsList = swiftnetProductList !== undefined ? productsList.concat(swiftnetProductList) : productsList;
    if (selectedProducts.length > 0) {
      this.productEnablement.productEnablements = productsList.reduce((acc, product) => {
        if (selectedProducts.indexOf(product.id) !== -1) {
          acc.push(product);
        }
        return acc;
      }, []);
    }
    // if (currentEchannel.eChannelType.value === ECHANNEL_HSBCAPI) {
    //   this.productEnablement.otherProductEnablements = otherAccountLevelProducts;
    // }
    // else {
    //   this.productEnablement.otherProductEnablements = selectedOtherProducts;
    // }
    this.productEnablement.otherProductEnablements = selectedOtherProducts;


  }
}

class ApplyEditedSettingsPayload {
  constructor() {
    this.productEnablement = {};
  }
  setPayload(accountForEditType, editedProducts, selectedOtherProducts, productsList, swiftnetProductList, accountId, accountsReportingToEchannel) {
    if (accountForEditType === 'gdocs-account') {
      let includeAccInAccountIdies = true;
      let glsId, achCreditId;
      let accId;
      for (let acc of accountsReportingToEchannel) {
        if (acc.id == accountId && (acc.hasOwnProperty('echannelReportedGlsId') || acc.hasOwnProperty('echannelReportedAchCreditId'))) {
          includeAccInAccountIdies = false;
          if (acc.hasOwnProperty('echannelReportedGlsId')) {
            glsId = acc.echannelReportedGlsId;
          } else if (acc.hasOwnProperty('echannelReportedAchCreditId')) {
            achCreditId = acc.echannelReportedAchCreditId;
          }
          accId = acc.id;
          break;
        }
      }
      if (includeAccInAccountIdies) {
        this.productEnablement.accountIdies = [accountId];
      } else {
        let accToReport;
        if (glsId) {
          accToReport = {
            glsId,
            accountId: accId
          }
          this.productEnablement.glsEchannelMap = [accToReport];
        } else if (achCreditId) {
          accToReport = {
            achCreditId,
            accountId: accId
          }
          this.productEnablement.achCreditEchannelMap = [accToReport];
        }
      }
    } else {
      this.productEnablement.otherAccountIdies = [accountId];
    }
    productsList = swiftnetProductList !== undefined ? productsList.concat(swiftnetProductList) : productsList;
    if (editedProducts.length > 0) {
      this.productEnablement.productEnablements = productsList.reduce((acc, product) => {
        if (editedProducts.indexOf(product.id) !== -1) {
          acc.push(product);
        }
        return acc;
      }, []);
    }

    //Following adds the accounts reported to GLS to payload
    this.productEnablement.otherProductEnablements = selectedOtherProducts;
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    currentProductEchannel: state.currentProductEchannel,
    persons: state.persons,
    addresses: state.addresses,
    productDetails: state.productDetails,
    displayTabIndex: state.currentProductEchannel.activeTabIndex,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductEchannel: productsEchanneldata => {
      dispatch(setCurrentProductEchannel(productsEchanneldata))
    },
    setCurrentProductEchannelStatuses: statuses => {
      dispatch(setCurrentProductEchannelStatuses(statuses))
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    setEChannelActiveTabIndex: index => {
      dispatch(setEChannelActiveTabIndex(index))
    },
    reSetEChannelActiveTabIndex: () => {
      dispatch(reSetEChannelActiveTabIndex())
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductEchannel);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductEchannel/index.js